<template>
  <section class="viewsrhqy_RailwayTicketManage p-4 space-y-2">
    <viewTitle :title="pageTitle" :showReturn="false" />

    <el-form :inline="true" :model="queryParam" :class="['search-form-inline', { 'search-form-inline--collect': activeTab === 'collect' }]">
      <template v-if="activeTab === 'region'">
        <el-form-item label="价格执行时间">
          <el-date-picker
            v-model="queryParam.price_execute_time"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择"
            class="w-44"
          />
        </el-form-item>
        <el-form-item label="物料号">
          <el-input clearable v-model="queryParam.material_code" placeholder="请输入物料号" class="w-48" />
        </el-form-item>
        <el-form-item label="物料描述">
          <el-input clearable v-model="queryParam.material_desc" placeholder="请输入物料描述" class="w-60" />
        </el-form-item>
        <el-form-item label="区域">
          <el-input clearable v-model="queryParam.region" placeholder="请输入区域" class="w-48" />
        </el-form-item>
        <el-form-item label="发站">
          <el-input clearable v-model="queryParam.departure_station" placeholder="请输入发站" class="w-48" />
        </el-form-item>
        <el-form-item label="到站">
          <el-input clearable v-model="queryParam.arrival_station" placeholder="请输入到站" class="w-48" />
        </el-form-item>
        <el-form-item label="审核">
          <el-select clearable v-model="queryParam.audit_state" placeholder="请选择" class="w-36">
            <el-option v-for="item in auditOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
      </template>

      <template v-if="activeTab === 'factory'">
        <el-form-item label="物料描述">
          <el-input clearable v-model="queryParam.material_desc" placeholder="请输入物料描述" class="w-60" />
        </el-form-item>
        <el-form-item label="供应商名称">
          <el-input clearable v-model="queryParam.supplier_name" placeholder="请输入供应商名称" class="w-60" />
        </el-form-item>
        <el-form-item label="发站">
          <el-input clearable v-model="queryParam.departure_station" placeholder="请输入发站" class="w-48" />
        </el-form-item>
        <el-form-item label="到站">
          <el-input clearable v-model="queryParam.arrival_station" placeholder="请输入到站" class="w-48" />
        </el-form-item>
        <el-form-item label="装载方式">
          <el-select clearable v-model="queryParam.load_type" placeholder="请选择" class="w-36">
            <el-option v-for="item in loadTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="审核">
          <el-select clearable v-model="queryParam.audit_state" placeholder="请选择" class="w-36">
            <el-option v-for="item in auditOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
      </template>

      <template v-if="activeTab === 'collect'">
        <el-form-item label="木片厂名称">
          <el-input clearable v-model="queryParam.chip_name" placeholder="请输入木片厂名称" class="w-60" />
        </el-form-item>
        <el-form-item label="物料描述">
          <el-input clearable v-model="queryParam.material_desc" placeholder="请输入物料描述" class="w-60" />
        </el-form-item>
        <el-form-item label="车号/集装箱号">
          <el-input clearable v-model="queryParam.container_no" placeholder="请输入车号/集装箱号" class="w-60" />
        </el-form-item>
        <el-form-item label="制票时间">
          <el-date-picker
            v-model="queryParam.ticket_time_range"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            class="railway-collect-ticket-time"
          />
        </el-form-item>
        <el-form-item label="人工复核通过">
          <el-select clearable v-model="queryParam.review_passed" placeholder="请选择" class="railway-collect-review-passed">
            <el-option v-for="item in reviewOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item class="railway-collect-actions-item">
          <div class="railway-collect-actions railway-collect-actions--primary">
            <el-button size="small" @click="resetSearch">重置</el-button>
            <el-button
              type="primary"
              size="small"
              :loading="collectRefreshSubmitting || collectRefreshRunning"
              :disabled="collectRefreshSubmitting || collectRefreshRunning || !hasRailwayPermission('collect', 'refresh')"
              @click="submitCollectRefreshTask"
            >
              {{ collectRefreshButtonText }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="运输方式" class="railway-collect-filter-item">
          <el-select clearable v-model="queryParam.transport_type" placeholder="请选择" class="w-36">
            <el-option v-for="item in transportOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="装载方式" class="railway-collect-filter-item">
          <el-select clearable v-model="queryParam.load_type" placeholder="请选择" class="w-36">
            <el-option v-for="item in loadTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item class="railway-collect-secondary-actions-item">
          <div class="railway-collect-actions railway-collect-actions--secondary">
            <el-button type="primary" size="small" :disabled="!hasRailwayPermission('collect', 'add')" @click="openEdit('collectManual')">添加</el-button>
            <el-button size="small" :disabled="!hasRailwayPermission('collect', 'downloadAttachment')" @click="downloadSelectedAttachments">批量下载附件</el-button>
            <el-button size="small" :disabled="!hasRailwayPermission('collect', 'export')" @click="exportData">导出</el-button>
            <el-button type="danger" size="small" :disabled="!hasRailwayPermission('collect', 'delete')" @click="deleteCollect">删除</el-button>
          </div>
        </el-form-item>
      </template>

      <template v-if="activeTab === 'prepayRatio'">
        <el-form-item label="执行时间">
          <el-date-picker
            v-model="queryParam.execute_time"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择"
            class="w-44"
          />
        </el-form-item>
      </template>

      <template v-if="activeTab === 'prepay'">
        <el-form-item label="木片厂">
          <el-input clearable v-model="queryParam.chip_name" placeholder="请输入木片厂" class="w-58" />
        </el-form-item>
        <el-form-item label="订单号">
          <el-input clearable v-model="queryParam.order_code" placeholder="请输入订单号" class="w-58" />
        </el-form-item>
        <el-form-item label="集装箱号">
          <el-input clearable v-model="queryParam.container_no" placeholder="请输入集装箱号" class="w-58" />
        </el-form-item>
        <el-form-item label="预付款审核">
          <el-select clearable v-model="queryParam.prepay_audit" placeholder="请选择" class="w-36">
            <el-option v-for="item in reviewOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="审核通过">
          <el-select clearable v-model="queryParam.approval_passed" placeholder="请选择" class="w-36">
            <el-option v-for="item in reviewOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="filterData">筛选</el-button>
          <el-button size="small" @click="resetSearch">重置</el-button>
        </el-form-item>
      </template>

      <template v-if="activeTab === 'statement'">
        <el-form-item label="木片厂">
          <el-input clearable v-model="queryParam.chip_name" placeholder="请输入木片厂" class="w-60" />
        </el-form-item>
        <el-form-item label="订单号">
          <el-input clearable v-model="queryParam.order_code" placeholder="请输入订单号" class="w-60" />
        </el-form-item>
        <el-form-item label="集装箱号">
          <el-input clearable v-model="queryParam.container_no" placeholder="请输入集装箱号" class="w-60" />
        </el-form-item>
      </template>

      <el-form-item v-if="activeTab !== 'prepay' && activeTab !== 'collect'">
        <el-button type="primary" size="small" @click="refreshData">刷新数据</el-button>
        <el-button size="small" @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>

    <div v-if="activeTab !== 'collect'" class="table-toolbar space-x-2">
      <el-button v-if="activeTab === 'region'" type="primary" size="small" :disabled="!hasRailwayPermission('region', 'add')" @click="openEdit('region')">新增区域价</el-button>
      <el-button v-if="activeTab === 'factory'" type="primary" size="small" :disabled="!hasRailwayPermission('factory', 'add')" @click="openEdit('factory')">新增专厂价</el-button>
      <el-button v-if="canImport" size="small" :disabled="!hasRailwayPermission(activeTab, 'import')" @click="openImport">导入</el-button>
      <el-button v-if="activeTab === 'prepayRatio'" type="primary" size="small" :disabled="!hasAnyPermission(['c-railway-ticket-savePrice'])" @click="openEdit('prepayRatio')">新增预付比例</el-button>
      <el-button v-if="activeTab === 'collect'" size="small" :disabled="!hasRailwayPermission('collect', 'downloadAttachment')" @click="downloadSelectedAttachments">批量下载附件</el-button>
      <el-button v-if="activeTab === 'collect'" type="danger" size="small" :disabled="!hasRailwayPermission('collect', 'delete')" @click="deleteCollect">删除</el-button>
      <el-button v-if="activeTab === 'collect'" type="primary" size="small" :disabled="!hasRailwayPermission('collect', 'syncPrepay')" @click="syncSelected('prepay')">同步预付款</el-button>
      <el-button v-if="activeTab === 'prepay'" type="primary" size="small" :disabled="!hasRailwayPermission('collect', 'syncStatement')" @click="syncSelected('statement')">同步对账单</el-button>
      <el-button v-if="activeTab === 'statement'" type="primary" size="small" :loading="statementRefreshLoading" @click="refreshStatementPoundData">刷新磅单数据</el-button>
      <el-button size="small" :disabled="!hasRailwayPermission(activeTab, 'export')" @click="exportData">导出</el-button>
    </div>

    <c-table
      ref="railwayTicketTable"
      :key="activeTab"
      :class="['mt-4', 'railway-ticket-table', { 'railway-ticket-table--sticky': stickyFooterTabs.includes(activeTab) }]"
      :isSelection="isSelectable"
      :selectable="tableSelectable"
      :selection.sync="rowKeySelection"
      :selectRows.sync="selectedRows"
      :data="dataSource"
      :columns="activeConfig.columns"
      :query.sync="pagination"
      :total="total"
      :showPagination="false"
      height="100%"
      row-key="id"
      @loadPage="loadData"
    >
      <template slot="ticket_file" slot-scope="{ row }">
        <template v-if="ticketFiles(row).length">
          <a
            v-for="(file, index) in ticketFiles(row)"
            :key="`${row.id || 'ticket'}-${index}`"
            :href="ticketFileViewerUrl(row, file)"
            target="_blank"
            class="ticket-file-link"
          >
            {{ ticketFiles(row).length > 1 ? `查看附件${index + 1}` : "查看附件" }}
          </a>
        </template>
        <span v-else>--</span>
      </template>
      <template slot="action" slot-scope="{ row }">
        <div v-if="activeTab === 'region'" class="railway-action-group railway-action-group--double">
          <span class="railway-action-slot">
            <span v-if="Number(row.void_state) === 1" class="railway-action--voided">作废</span>
            <c-link v-else-if="Number(row.audit_state) === 1" :disabled="!hasRailwayPermission('region', 'void')" @click="voidPrice('region', row)" label="作废" type="danger" />
            <c-link v-else :disabled="!hasRailwayPermission('region', 'edit')" @click="openEdit('region', row)" label="编辑" type="primary" />
          </span>
          <span class="railway-action-slot">
            <span v-if="Number(row.void_state) === 1 || Number(row.audit_state) === 1" class="railway-action--voided">审核</span>
            <c-link
              v-else
              :disabled="!hasRailwayPermission('region', 'audit')"
              @click="auditPrice('region', row)"
              label="审核"
              type="success"
            />
          </span>
          <span class="railway-action-slot">
            <c-link @click="openRecordLog('region', row)" label="查看" type="info" />
          </span>
        </div>
        <div v-else-if="activeTab === 'factory'" class="railway-action-group railway-action-group--double">
          <span class="railway-action-slot">
            <span v-if="Number(row.void_state) === 1" class="railway-action--voided">作废</span>
            <c-link v-else-if="Number(row.audit_state) === 1" :disabled="!hasRailwayPermission('factory', 'void')" @click="voidPrice('factory', row)" label="作废" type="danger" />
            <c-link v-else :disabled="!hasRailwayPermission('factory', 'edit')" @click="openEdit('factory', row)" label="编辑" type="primary" />
          </span>
          <span class="railway-action-slot">
            <span v-if="Number(row.void_state) === 1 || Number(row.audit_state) === 1" class="railway-action--voided">审核</span>
            <c-link
              v-else
              :disabled="!hasRailwayPermission('factory', 'audit')"
              @click="auditPrice('factory', row)"
              label="审核"
              type="success"
            />
          </span>
          <span class="railway-action-slot">
            <c-link @click="openRecordLog('factory', row)" label="查看" type="info" />
          </span>
        </div>
        <div v-else class="railway-action-group railway-action-group--single">
          <c-link v-if="activeTab === 'prepayRatio'" :disabled="!hasAnyPermission(['c-railway-ticket-savePrice'])" @click="openEdit('prepayRatio', row)" label="编辑" type="primary" />
          <c-link v-if="activeTab === 'collect'" :disabled="!hasRailwayPermission('collect', 'review')" @click="openEdit('review', row)" label="复核" type="primary" />
          <c-link v-if="activeTab === 'collect'" @click="openRecordLog('collect', row)" label="查看" type="info" />
          <c-link v-if="activeTab === 'prepay'" :disabled="!hasRailwayPermission('collect', 'savePrepay')" @click="openEdit('prepay', row)" label="审核" type="primary" />
          <c-link v-if="activeTab === 'statement'" :disabled="!hasRailwayPermission('collect', 'updateContainer')" @click="openStatementContainerEdit(row)" label="改箱号" type="warning" />
        </div>
      </template>
    </c-table>

    <div class="railway-pagination-bar mt-4">
      <div class="railway-pagination-bar__summary">
        <span>{{ paginationSummaryText }}</span>
      </div>
      <div class="railway-pagination-bar__actions">
        <el-select
          v-model="pagination.page_size"
          size="small"
          class="railway-pagination-bar__size"
          @change="changePageSize"
        >
          <el-option v-for="size in pageSizeOptions" :key="size" :label="`${size}条/页`" :value="size" />
        </el-select>
        <el-button size="small" :disabled="pagination.page <= 1" @click="changePage(pagination.page - 1)">上一页</el-button>
        <el-select
          :value="pagination.page"
          size="small"
          class="railway-pagination-bar__page-select"
          :disabled="!pageSelectOptions.length"
          @change="changePage"
        >
          <el-option v-for="page in pageSelectOptions" :key="page" :label="`第 ${page} 页`" :value="page" />
        </el-select>
        <el-button size="small" :disabled="!hasMore" @click="changePage(pagination.page + 1)">下一页</el-button>
      </div>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="editVisible" width="680px" top="4vh" :class="{ 'railway-dialog--compact': ['review', 'container'].includes(editType) }" @close="handleDialogClose">
      <el-alert
        v-if="editType === 'prepay' && prepayDialogMessage"
        :title="prepayDialogMessage"
        type="warning"
        :closable="false"
        class="mb-4"
      />
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="10em">
        <el-form-item
          v-for="field in currentEditFields"
          :key="field.prop"
          :label="field.label"
          :prop="field.prop"
        >
          <el-select v-if="field.type === 'select'" v-model="editForm[field.prop]" clearable placeholder="请选择">
            <el-option
              v-for="option in fieldOptions(field)"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
          <el-date-picker
            v-else-if="field.type === 'date'"
            v-model="editForm[field.prop]"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择日期"
          />
          <el-input
            v-else-if="field.type === 'textarea'"
            v-model="editForm[field.prop]"
            type="textarea"
            :rows="3"
            placeholder="请输入"
          />
          <el-input-number
            v-else-if="field.type === 'number'"
            v-model="editForm[field.prop]"
            :precision="field.precision || 2"
            :min="0"
          />
          <c-file-upload
            v-else-if="field.type === 'upload'"
            v-model="editForm[field.prop]"
            :limit="field.limit || 5"
            :isShowTip="false"
          />
          <el-input v-else-if="field.readonly" :value="editForm[field.prop]" disabled />
          <el-input v-else v-model="editForm[field.prop]" clearable placeholder="请输入" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button v-if="editType" type="primary" :disabled="!hasAnyPermission(saveDialogPermissions)" @click="saveDialog">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="recordLogDialogTitle" :visible.sync="logVisible" width="760px" top="8vh" @close="handleRecordLogDialogClose">
      <div class="railway-log-dialog">
        <el-table v-loading="logLoading" :data="logRows" border size="small" empty-text="暂无日志">
          <el-table-column label="操作时间" width="180">
            <template slot-scope="{ row }">
              {{ formatDateTime(row.create_time) }}
            </template>
          </el-table-column>
          <el-table-column prop="operator_name" label="操作人" width="120" />
          <el-table-column label="操作内容" min-width="420">
            <template slot-scope="{ row }">
              <div class="railway-log-content">{{ row.content || "--" }}</div>
              <div v-if="row._changeDetailList && row._changeDetailList.length" class="railway-log-detail-list">
                <div v-for="(item, index) in row._changeDetailList" :key="`${row.id || index}-${item.field || index}`" class="railway-log-detail-item">
                  <span class="railway-log-detail-item__label">{{ item.label }}：</span>
                  <span class="railway-log-detail-item__value">{{ item.before }} -> {{ item.after }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="railway-log-dialog__pagination">
          <el-pagination
            background
            layout="prev, pager, next, total"
            :current-page="logQuery.page"
            :page-size="logQuery.page_size"
            :total="logTotal"
            @current-change="changeLogPage"
          />
        </div>
      </div>
    </el-dialog>

    <c-import v-bind="importOptions" :show.sync="showImport" @finish="handleImportFinish">
      <span slot="desc">
        <span>3、导入后的价格默认为未审核，审核通过后才参与价格匹配</span>
        <br />
        <span>4、装载方式、运输方式等字段必须使用表格固定选项，日期格式统一为 yyyy-MM-dd</span>
        <br />
        <span v-if="activeTab === 'prepayRatio'">5、预付比例必须填写 0 到 1 之间的小数，例如 0.3 表示 30%</span>
        <br v-if="activeTab === 'prepayRatio'" />
      </span>
    </c-import>
  </section>
</template>

<script>
import moment from "moment";

const DEBUG_DOWNLOAD_SERVER_URL = "http://127.0.0.1:7777/event";
const DEBUG_DOWNLOAD_SESSION_ID = "download-record-missing";
const DEBUG_DOWNLOAD_RUN_ID = "post-fix";
const ENABLE_DOWNLOAD_DEBUG = false;
const PRICE_SNAPSHOT_REFRESH_TASK_STORAGE_KEY = "railway-price-snapshot-refresh-task";
const createDefaultPagination = () => ({
  page: 1,
  page_size: 10
});
const clonePlainData = value => JSON.parse(JSON.stringify(value || {}));
const EDIT_BRACKET_FIELDS_MAP = {
  region: ["material_code", "material_desc", "region", "departure_station", "arrival_station"],
  factory: ["order_code", "material_desc", "supplier_name", "departure_station", "arrival_station"],
  collectManual: ["order_code", "material_desc", "supplier_name", "departure_station", "arrival_station", "container_no", "chip_name"],
  review: ["departure_station", "arrival_station", "container_no", "shipper_name", "review_remark"],
  container: ["container_no"]
};

export default {
  data() {
    return {
      activeTab: "region",
      queryParam: {},
      pagination: createDefaultPagination(),
      pageSizeOptions: [10, 20, 30, 50, 100, 200],
      dataSource: [],
      total: 0,
      hasMore: false,
      totalCountLoaded: false,
      activeTabLoaded: false,
      pendingRestoreScrollTop: null,
      tabViewStateMap: {},
      tableBodyScrollTarget: null,
      statementRefreshLoading: false,
      rowKeySelection: [],
      selectedRows: [],
      collectRefreshSubmitting: false,
      collectRefreshTaskId: "",
      collectRefreshTaskPercent: "0.00",
      collectRefreshTaskRemark: "",
      collectRefreshTaskFinished: true,
      collectRefreshProgressTimer: null,
      pendingCollectChangeGroupCount: 0,
      pendingCollectCount: 0,
      pendingCollectSummaryLoading: false,
      priceSnapshotRefreshSubmitting: false,
      priceSnapshotRefreshTab: "",
      priceSnapshotRefreshTaskId: "",
      priceSnapshotRefreshTaskPercent: "0.00",
      priceSnapshotRefreshTaskRemark: "",
      priceSnapshotRefreshTaskFinished: true,
      priceSnapshotRefreshProgressFailureCount: 0,
      priceSnapshotRefreshProgressTimer: null,
      logVisible: false,
      logLoading: false,
      logRows: [],
      logTotal: 0,
      logQuery: {
        page: 1,
        page_size: 10
      },
      logContext: {
        bizType: "",
        bizId: "",
        label: ""
      },
      showImport: false,
      editVisible: false,
      editType: "",
      editAuditState: 0,
      editForm: {},
      tabLabelMap: {
        region: "铁路区域定价",
        factory: "铁路专厂价格",
        collect: "铁路大票收集表",
        prepayRatio: "预付款比例",
        prepay: "预付款申请",
        statement: "对账单管理"
      },
      auditOptions: [
        { label: "未审核", value: 0 },
        { label: "已审核", value: 1 },
        { label: "作废", value: "void" }
      ],
      reviewOptions: [
        { label: "未通过", value: 0 },
        { label: "已通过", value: 1 }
      ],
      loadTypeOptions: [
        { label: "集装箱", value: "集装箱" },
        { label: "散装", value: "散装" },
        { label: "整车", value: "整车" }
      ],
      transportOptions: [
        { label: "门到门", value: "门到门" },
        { label: "门到站", value: "门到站" }
      ],
      stickyFooterTabs: ["collect", "prepay", "statement"],
      tableConfig: {
        region: {
          fetchUrl: "/api/queue/admin/query_railway_region_price",
          columns: [
            { label: "价格执行时间", prop: "price_execute_time", formatData: row => this.formatDateValue(row.price_execute_time) },
            { label: "物料号", prop: "material_code" },
            { label: "物料描述", prop: "material_desc" },
            { label: "区域", prop: "region" },
            { label: "发站", prop: "departure_station" },
            { label: "到站", prop: "arrival_station" },
            { label: "装载方式", prop: "load_type" },
            { label: "运输方式", prop: "transport_type" },
            { label: "区域单价", prop: "region_price" },
            { label: "审核状态", prop: "audit_state", formatData: row => this.formatPriceAuditStatus(row) },
            { label: "审核人", prop: "audit_user_name" },
            { label: "审核时间", prop: "audit_time", formatData: row => this.formatUnixTime(row.audit_time) },
            { label: "操作", prop: "action", width: "148px", fixed: "right", className: "railway-action-column", labelClassName: "railway-action-column" }
          ]
        },
        factory: {
          fetchUrl: "/api/queue/admin/query_railway_factory_price",
          columns: [
            { label: "价格执行时间", prop: "price_execute_time", formatData: row => this.formatDateValue(row.price_execute_time) },
            { label: "结束时间", prop: "end_time", formatData: row => this.formatDateValue(row.end_time) },
            { label: "订单号", prop: "order_code" },
            { label: "物料描述", prop: "material_desc" },
            { label: "供应商名称", prop: "supplier_name" },
            { label: "发站", prop: "departure_station" },
            { label: "到站", prop: "arrival_station" },
            { label: "装载方式", prop: "load_type" },
            { label: "运输方式", prop: "transport_type" },
            { label: "专厂单价", prop: "factory_price" },
            { label: "审核状态", prop: "audit_state", formatData: row => this.formatPriceAuditStatus(row) },
            { label: "审核人", prop: "audit_user_name" },
            { label: "审核时间", prop: "audit_time", formatData: row => this.formatUnixTime(row.audit_time) },
            { label: "操作", prop: "action", width: "148px", fixed: "right", className: "railway-action-column", labelClassName: "railway-action-column" }
          ]
        },
        collect: {
          fetchUrl: "/api/queue/admin/query_railway_ticket_collect",
          columns: [
            { label: "提交时间", prop: "submit_time", formatData: row => this.formatSubmitTime(row.submit_time) },
            { label: "提交方式", prop: "submit_type", formatData: row => this.formatCollectSubmitType(row.submit_type) },
            { label: "木片厂名称", prop: "chip_name" },
            { label: "打卡账号", prop: "submit_account" },
            { label: "订单号", prop: "order_code" },
            { label: "供应商名称", prop: "supplier_name" },
            { label: "物料描述", prop: "material_desc" },
            { label: "托运人名称", prop: "shipper_name" },
            { label: "起运重量", prop: "start_weight" },
            { label: "制票时间", prop: "ticket_time", formatData: row => this.formatDateValue(row.ticket_time) },
            { label: "发站", prop: "departure_station" },
            { label: "到站", prop: "arrival_station" },
            { label: "车号/集装箱号", prop: "container_no" },
            { label: "装载方式", prop: "load_type" },
            { label: "运输方式", prop: "transport_type" },
            { label: "大票附件", prop: "ticket_file" },
            { label: "专厂单价", prop: "factory_price", rowClass: row => this.collectChangedFieldClass(row) },
            { label: "区域单价", prop: "region_price", rowClass: row => this.collectChangedFieldClass(row) },
            { label: "结算单价", prop: "settlement_price", rowClass: row => this.collectChangedFieldClass(row) },
            { label: "送货单号", prop: "deliver_code" },
            { label: "系统备注错误", prop: "system_error_remark" },
            { label: "人工复核通过", prop: "review_passed", formatData: row => this.formatTickOrDash(row.review_passed) },
            { label: "复核备注", prop: "review_remark" },
            { label: "修改时间", prop: "review_time", formatData: row => this.formatUnixTime(row.review_time) },
            { label: "修改人员", prop: "review_user_name" },
            { label: "同步至预付款表单", prop: "sync_prepay", formatData: row => this.formatSyncPrepayStatus(row.sync_prepay) },
            { label: "操作", prop: "action", width: "96px", fixed: "right", className: "railway-action-column", labelClassName: "railway-action-column" }
          ]
        },
        prepayRatio: {
          fetchUrl: "/api/queue/admin/query_railway_prepay_ratio",
          columns: [
            { label: "预付比例执行时间", prop: "execute_time", formatData: row => this.formatDateValue(row.execute_time) },
            { label: "预付比例", prop: "prepay_ratio", formatData: row => this.formatPercentValue(row.prepay_ratio) },
            { label: "保存", prop: "audit_state", formatData: row => this.formatCheckMark(row.audit_state) },
            { label: "保存人", prop: "audit_user_name" },
            { label: "生效时间", prop: "audit_time", formatData: row => this.formatUnixTime(row.audit_time) },
            { label: "操作", prop: "action" }
          ]
        },
        prepay: {
          fetchUrl: "/api/queue/admin/query_railway_prepay",
          columns: [
            { label: "提交时间", prop: "submit_time", formatData: row => this.formatSubmitTime(row.submit_time) },
            { label: "木片厂", prop: "chip_name" },
            { label: "打卡账号", prop: "submit_account" },
            { label: "订单号", prop: "order_code" },
            { label: "供应商名称", prop: "supplier_name" },
            { label: "物料描述", prop: "material_desc" },
            { label: "运输方式", prop: "transport_type" },
            { label: "制票时间", prop: "ticket_time", formatData: row => this.formatDateValue(row.ticket_time) },
            { label: "发站", prop: "departure_station" },
            { label: "到站", prop: "arrival_station" },
            { label: "装载方式", prop: "load_type" },
            { label: "集装箱号", prop: "container_no" },
            { label: "起运重量", prop: "start_weight" },
            { label: "发运人", prop: "shipper_name" },
            { label: "专厂单价", prop: "factory_price" },
            { label: "区域单价", prop: "region_price" },
            { label: "结算单价", prop: "settlement_price" },
            { label: "大票附件", prop: "ticket_file" },
            { label: "人工复核通过", prop: "review_passed", formatData: row => this.formatTickOrDash(row.review_passed) },
            { label: "复核备注", prop: "review_remark" },
            { label: "同步至预付款表单", prop: "ticket_collect_id", formatData: () => "√" },
            { label: "预付比例", prop: "prepay_ratio" },
            { label: "预付金额", prop: "prepay_amount" },
            { label: "预付申请时间", prop: "prepay_apply_time", formatData: row => this.formatDateValue(row.prepay_apply_time) },
            { label: "预付申请单", prop: "prepay_apply_no" },
            { label: "预付款审核", prop: "prepay_audit", formatData: row => this.formatTickOrDash(row.prepay_audit) },
            { label: "预付款审核人", prop: "prepay_audit_user_name" },
            { label: "审核时间", prop: "prepay_audit_time", formatData: row => this.formatUnixTime(row.prepay_audit_time) },
            { label: "审核通过", prop: "approval_passed", formatData: row => this.formatTickOrDash(row.approval_passed) },
            { label: "同步至对账单", prop: "sync_statement", formatData: row => this.formatSyncStatementStatus(row.sync_statement) },
            { label: "操作", prop: "action" }
          ]
        },
        statement: {
          fetchUrl: "/api/queue/admin/query_railway_statement",
          columns: [
            { label: "提交时间", prop: "submit_time", formatData: row => this.formatSubmitTime(row.submit_time) },
            { label: "木片厂", prop: "chip_name" },
            { label: "打卡账号", prop: "submit_account" },
            { label: "订单号", prop: "order_code" },
            { label: "供应商名称", prop: "supplier_name" },
            { label: "物料描述", prop: "material_desc" },
            { label: "运输方式", prop: "transport_type" },
            { label: "制票时间", prop: "ticket_time", formatData: row => this.formatDateValue(row.ticket_time) },
            { label: "发站", prop: "departure_station" },
            { label: "到站", prop: "arrival_station" },
            { label: "装载方式", prop: "load_type" },
            { label: "集装箱号", prop: "container_no" },
            { label: "起运重量", prop: "start_weight" },
            { label: "发运人", prop: "shipper_name" },
            { label: "专厂单价", prop: "factory_price" },
            { label: "区域单价", prop: "region_price" },
            { label: "结算单价", prop: "settlement_price" },
            { label: "大票附件", prop: "ticket_file" },
            { label: "人工复核通过", prop: "review_passed", formatData: row => this.formatTickOrDash(row.review_passed) },
            { label: "复核备注", prop: "review_remark" },
            { label: "同步至预付款表单", prop: "ticket_collect_id", formatData: () => "√" },
            { label: "预付款比例", prop: "prepay_ratio" },
            { label: "预付金额", prop: "prepay_amount" },
            { label: "预付申请时间", prop: "prepay_apply_time", formatData: row => this.formatDateValue(row.prepay_apply_time) },
            { label: "预付申请单", prop: "prepay_apply_no" },
            { label: "预付款审核", prop: "prepay_audit", formatData: row => this.formatTickOrDash(row.prepay_audit) },
            { label: "预付款审核人", prop: "prepay_audit_user_name" },
            { label: "审核时间", prop: "prepay_audit_time", formatData: row => this.formatUnixTime(row.prepay_audit_time) },
            { label: "审核通过", prop: "approval_passed", formatData: row => this.formatTickOrDash(row.approval_passed) },
            { label: "磅单号", prop: "pound_code" },
            { label: "磅单单价", prop: "pound_price" },
            { label: "磅单订单号", prop: "pound_order_code" },
            { label: "司磅净重", prop: "pound_net_weight" },
            { label: "应付金额", prop: "payable_amount" },
            { label: "剩余应付金额", prop: "remain_payable_amount" }
          ]
        }
      },
      saveUrlMap: {
        region: "/api/queue/admin/save_railway_region_price",
        factory: "/api/queue/admin/save_railway_factory_price",
        prepayRatio: "/api/queue/admin/save_railway_prepay_ratio",
        review: "/api/queue/admin/review_railway_ticket_collect",
        collectManual: "/api/queue/admin/save_railway_ticket_collect_manually",
        prepay: "/api/queue/admin/save_railway_prepay",
        container: "/api/queue/admin/update_railway_container_no"
      },
      editFieldMap: {
        region: [
          { label: "价格执行时间", prop: "price_execute_time", type: "date", required: true },
          { label: "物料号", prop: "material_code", required: true },
          { label: "物料描述", prop: "material_desc", required: true },
          { label: "区域", prop: "region" },
          { label: "发站", prop: "departure_station", required: true },
          { label: "到站", prop: "arrival_station", required: true },
          { label: "装载方式", prop: "load_type", type: "select", optionsKey: "loadTypeOptions", required: true },
          { label: "运输方式", prop: "transport_type", type: "select", optionsKey: "transportOptions", required: true },
          { label: "区域单价", prop: "region_price", type: "number", precision: 2, required: true }
        ],
        factory: [
          { label: "价格执行时间", prop: "price_execute_time", type: "date", required: true },
          { label: "结束时间", prop: "end_time", type: "date", required: true },
          { label: "订单号", prop: "order_code", required: true },
          { label: "物料描述", prop: "material_desc", required: true },
          { label: "供应商名称", prop: "supplier_name", required: true },
          { label: "发站", prop: "departure_station", required: true },
          { label: "到站", prop: "arrival_station", required: true },
          { label: "装载方式", prop: "load_type", type: "select", optionsKey: "loadTypeOptions", required: true },
          { label: "运输方式", prop: "transport_type", type: "select", optionsKey: "transportOptions", required: true },
          { label: "专厂单价", prop: "factory_price", type: "number", precision: 2, required: true }
        ],
        collectManual: [
          { label: "木片厂名称", prop: "chip_name", required: true },
          { label: "打卡账号", prop: "submit_account", required: true },
          { label: "订单号", prop: "order_code", required: true },
          { label: "供应商名称", prop: "supplier_name", required: true },
          { label: "物料描述", prop: "material_desc", required: true },
          { label: "托运人名称", prop: "shipper_name", required: true },
          { label: "起运重量", prop: "start_weight", type: "number", precision: 2 },
          { label: "制票时间", prop: "ticket_time", type: "date", required: true },
          { label: "发站", prop: "departure_station", required: true },
          { label: "到站", prop: "arrival_station", required: true },
          { label: "集装箱号", prop: "container_no", required: true },
          { label: "装载方式", prop: "load_type", type: "select", optionsKey: "loadTypeOptions", required: true },
          { label: "运输方式", prop: "transport_type", type: "select", optionsKey: "transportOptions", required: true },
          { label: "大票附件", prop: "ticket_file", type: "upload", limit: 5, required: true }
        ],
        prepayRatio: [
          { label: "预付比例执行时间", prop: "execute_time", type: "date", required: true },
          { label: "预付比例", prop: "prepay_ratio", type: "number", precision: 4, required: true }
        ],
        review: [
          { label: "制票时间", prop: "ticket_time", type: "date", required: true },
          { label: "发站", prop: "departure_station", required: true },
          { label: "到站", prop: "arrival_station", required: true },
          { label: "装载方式", prop: "load_type", type: "select", optionsKey: "loadTypeOptions", required: true },
          { label: "集装箱号", prop: "container_no", required: true },
          { label: "起运重量", prop: "start_weight", type: "number", precision: 2 },
          { label: "托运人", prop: "shipper_name" },
          { label: "专厂单价", prop: "factory_price", readonly: true },
          { label: "区域单价", prop: "region_price", readonly: true },
          { label: "结算价", prop: "settlement_price", type: "number", precision: 2 },
          { label: "复核状态", prop: "review_passed", type: "select", optionsKey: "reviewOptions", required: true },
          { label: "复核备注", prop: "review_remark", type: "textarea" }
        ],
        prepay: [
          { label: "申请时间", prop: "prepay_apply_time", type: "date" },
          { label: "预付申请单", prop: "prepay_apply_no" },
          { label: "预付审核", prop: "prepay_audit", type: "select", optionsKey: "reviewOptions", required: true },
          { label: "审核通过", prop: "approval_passed", type: "select", optionsKey: "reviewOptions", required: true }
        ],
        container: [
          { label: "集装箱号", prop: "container_no", required: true }
        ]
      }
    };
  },

  computed: {
    permissionKeys() {
      return (((this.$store || {}).state || {}).privilegeConfig || {}).keys || [];
    },
    pageTitle() {
      return `业务管理 / 铁路大票管理 / ${this.activeLabel}`;
    },
    activeLabel() {
      return this.$route.meta.pageTitle || this.tabLabelMap[this.activeTab] || "铁路大票管理";
    },
    activeConfig() {
      return this.tableConfig[this.activeTab] || this.tableConfig.region;
    },
    currentEditFields() {
      return this.editFieldMap[this.editType] || [];
    },
    canImport() {
      return ["region", "factory"].includes(this.activeTab);
    },
    collectRefreshRunning() {
      return this.activeTab === "collect" && !!this.collectRefreshTaskId && !this.collectRefreshTaskFinished;
    },
    collectRefreshButtonText() {
      if (this.collectRefreshSubmitting) {
        return "提交中...";
      }
      if (this.collectRefreshRunning) {
        return `刷新中(${this.collectRefreshTaskPercent}%)`;
      }
      return "刷新数据";
    },
    priceSnapshotRefreshRunning() {
      return !!this.priceSnapshotRefreshTaskId && !this.priceSnapshotRefreshTaskFinished;
    },
    activePriceSnapshotRefreshRunning() {
      return this.priceSnapshotRefreshRunning && this.priceSnapshotRefreshTab === this.activeTab;
    },
    priceSnapshotRefreshButtonDisabled() {
      if (!["region", "factory"].includes(this.activeTab)) {
        return false;
      }
      return (this.priceSnapshotRefreshSubmitting && this.priceSnapshotRefreshTab === this.activeTab) || this.activePriceSnapshotRefreshRunning;
    },
    defaultRefreshButtonText() {
      if (this.priceSnapshotRefreshButtonDisabled) {
        return "数据更新中";
      }
      return "刷新数据";
    },
    isSelectable() {
      return ["region", "factory", "collect", "prepay"].includes(this.activeTab);
    },
    tableSelectable() {
      return row => {
        return true;
      };
    },
    importOptions() {
      return {
        downloadDemoName: `${this.activeLabel}导入模板`,
        templateUrl: `/api/queue/admin/download_railway_import_template?type=${this.activeTab}`,
        uploadUrl: "/api/media/upload",
        importUrl: "/api/queue/admin/import_railway_price",
        progressUrl: "/api/queue/admin/get_imexport_progress",
        otherParams: {
          type: this.activeTab
        }
      };
    },
    dialogTitle() {
      const titleMap = {
        region: "铁路区域定价",
        factory: "铁路专厂价格",
        collectManual: "手动添加收集记录",
        prepayRatio: "预付款比例",
        review: "铁路大票复核",
        prepay: "预付款审核",
        container: "修改集装箱号"
      };
      return titleMap[this.editType] || "铁路大票管理";
    },
    recordLogDialogTitle() {
      return `${this.logContext.label || "铁路大票"}操作日志`;
    },
    saveDialogPermissions() {
      const permissionMap = {
        region: ["c-railway-region-add", "c-railway-region-edit", "c-railway-region-save", "c-railway-ticket-savePrice"],
        factory: ["c-railway-factory-add", "c-railway-factory-edit", "c-railway-factory-save", "c-railway-ticket-savePrice"],
        collectManual: ["c-railway-collect-add", "c-railway-ticket-addCollect"],
        prepayRatio: ["c-railway-ticket-savePrice"],
        review: ["c-railway-collect-review", "c-railway-ticket-reviewCollect", "c-railway-ticket-review"],
        prepay: ["c-railway-collect-savePrepay", "c-railway-ticket-savePrepay"],
        container: ["c-railway-collect-updateContainer", "c-railway-ticket-updateContainer"]
      };
      return permissionMap[this.editType] || [];
    },
    paginationSummaryText() {
      const start = (this.pagination.page - 1) * this.pagination.page_size + 1;
      const end = start + this.dataSource.length - 1;
      if (!this.dataSource.length) {
        return this.totalCountLoaded ? `当前页无数据，共${this.total}条记录` : "暂无数据";
      }
      if (this.totalCountLoaded) {
        return `第${start} ~ ${Math.min(end, this.total)}条记录，共${this.total}条记录`;
      }
      return `第${start} ~ ${end}条记录`;
    },
    totalPages() {
      if (!this.totalCountLoaded) {
        return 0;
      }
      return Math.max(1, Math.ceil(Number(this.total || 0) / Number(this.pagination.page_size || 10)));
    },
    pageSelectOptions() {
      const totalPages = this.totalPages;
      if (!this.totalCountLoaded || totalPages <= 0) {
        return [];
      }
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    },
    collectPendingSummaryText() {
      if (this.activeTab !== "collect") {
        return "";
      }
      if (this.pendingCollectSummaryLoading) {
        return "正在统计待同步价格变更影响范围...";
      }
      const groupCount = Number(this.pendingCollectChangeGroupCount || 0);
      if (groupCount <= 0) {
        return "当前没有待同步的价格变更";
      }
      const pendingCount = Number(this.pendingCollectCount || 0);
      // if (this.hasCollectExplicitFilters()) {
      //   return `当前累计 ${groupCount} 组价格变更，预计影响 ${pendingCount} 条；清空筛选后点击“刷新数据”可按这批变更精确更新`;
      // }
      // return `当前累计 ${groupCount} 组价格变更，预计影响 ${pendingCount} 条；当前无筛选，点击“刷新数据”将精确更新这批数据`;
    },
    reviewDialogMessage() {
      if (this.editType !== "review") {
        return "";
      }
      if (Number(this.editForm.sync_prepay) === 1) {
        return "这条收集记录之前已经处理过；如果你本次改了内容，保存后系统会重新标记为“数据已更新”。请确认价格和备注无误后再提交。";
      }
      if (Number(this.editForm.sync_prepay) === 2) {
        return "这条收集记录最近有价格或数据变化，当前处于“数据已更新”状态。请重点确认专厂价、区域价、结算价是否正确后再复核。";
      }
      if (Number(this.editForm.sync_prepay) === 3) {
        return "这条收集记录之前处理未完成，本次保存后会继续保留待跟进状态。请先确认当前价格和系统校验结果是否正确。";
      }
      if (Number(this.editForm.factory_price || 0) > 0) {
        return "当前已命中专厂价，请先人工确认结算价，并保证结算价大于 0 后再复核通过。";
      }
      if (this.editForm.system_error_remark) {
        return `系统校验仍有错误：${this.editForm.system_error_remark}`;
      }
      return "请先确认价格、重量和系统校验结果都正确，再进行复核；保存后系统会按最新内容重新校验这条记录。";
    },
    prepayDialogMessage() {
      if (this.editType !== "prepay") {
        return "";
      }
      if (Number(this.editForm.sync_statement) === 1) {
        return "该预付款申请已同步到对账单，如本次保存内容有变化，会标记为数据已更新，可再次同步回写对账单。";
      }
      if (Number(this.editForm.sync_statement) === 2) {
        return "该预付款申请已标记为数据已更新，再次同步对账单时会回写更新对应的下游数据。";
      }
      return "预付款审核通过时，预付申请时间和预付申请单必填；审核通过勾选为已通过前，预付款审核也必须已通过。";
    },
    editRules() {
      return this.currentEditFields.reduce((rules, field) => {
        if (field.required) {
          const isChoiceField = ["select", "date", "upload"].includes(field.type);
          const actionText = field.type === "upload" ? "上传" : (isChoiceField ? "选择" : "输入");
          const trigger = isChoiceField ? "change" : "blur";
          rules[field.prop] = [{ required: true, message: `请${actionText}${field.label}`, trigger }];
        }
        if (this.editType === "review" && field.prop === "settlement_price") {
          rules[field.prop] = [
            ...(rules[field.prop] || []),
            {
              validator: (rule, value, callback) => {
                if (this.reviewNeedsSettlementPrice() && !(Number(value) > 0)) {
                  callback(new Error("命中专厂价时，结算价需人工填写且大于0"));
                  return;
                }
                callback();
              },
              trigger: "blur"
            }
          ];
        }
        return rules;
      }, {});
    }
  },

  watch: {
    /**
     * 左侧二级菜单切换只改变路由，这里同步当前业务页并刷新列表。
     */
    $route(to) {
      if (this.isRailwayTicketRoute(to)) {
        this.syncActiveTabFromRoute();
      }
    },
    // #region debug-point D:show-import-watch
    showImport(val) {
      window.fetch("http://127.0.0.1:7777/event", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ sessionId: "railway-import-unavailable", runId: "pre-fix", hypothesisId: "D", location: "RailwayTicketManage.vue:showImport", msg: "[DEBUG] parent showImport changed", data: { activeTab: this.activeTab, showImport: val }, ts: Date.now() }) }).catch(() => {});
    }
    // #endregion
  },

  created() {
    this.syncActiveTabFromRoute(false);
    this.resetPriceSnapshotRefreshState();
    this.loadData();
  },

  activated() {
    if (this.isRailwayTicketRoute()) {
      this.resetPriceSnapshotRefreshState();
      this.syncActiveTabFromRoute();
      this.scheduleTableLayout();
    }
  },

  deactivated() {
    this.saveCurrentTabViewState();
  },

  beforeDestroy() {
    this.stopCollectRefreshProgressPolling();
    this.stopPriceSnapshotRefreshProgressPolling();
    this.unbindTableScrollListener();
  },

  methods: {
    hasAnyPermission(permission) {
      const permissions = Array.isArray(permission) ? permission : [permission];
      return permissions.some(item => this.permissionKeys.includes(item));
    },
    getRailwayPermissionKeys(module, action) {
      const permissionMap = {
        region: {
          query: ["c-railway-region-query", "c-railway-ticket-query"],
          add: ["c-railway-region-add", "c-railway-region-save", "c-railway-ticket-savePrice"],
          edit: ["c-railway-region-edit", "c-railway-region-save", "c-railway-ticket-savePrice"],
          void: ["c-railway-region-void", "c-railway-region-save", "c-railway-ticket-savePrice"],
          audit: ["c-railway-region-audit", "c-railway-ticket-auditPrice"],
          import: ["c-railway-region-import", "c-railway-ticket-import"],
          export: ["c-railway-region-export", "c-railway-ticket-export"]
        },
        factory: {
          query: ["c-railway-factory-query", "c-railway-ticket-query"],
          add: ["c-railway-factory-add", "c-railway-factory-save", "c-railway-ticket-savePrice"],
          edit: ["c-railway-factory-edit", "c-railway-factory-save", "c-railway-ticket-savePrice"],
          void: ["c-railway-factory-void", "c-railway-factory-save", "c-railway-ticket-savePrice"],
          audit: ["c-railway-factory-audit", "c-railway-ticket-auditPrice"],
          import: ["c-railway-factory-import", "c-railway-ticket-import"],
          export: ["c-railway-factory-export", "c-railway-ticket-export"]
        },
        collect: {
          query: ["c-railway-collect-query", "c-railway-ticket-query"],
          add: ["c-railway-collect-add", "c-railway-ticket-addCollect"],
          downloadAttachment: ["c-railway-collect-downloadAttachment"],
          export: ["c-railway-collect-export", "c-railway-ticket-export"],
          delete: ["c-railway-collect-delete", "c-railway-ticket-deleteCollect"],
          review: ["c-railway-collect-review", "c-railway-ticket-reviewCollect", "c-railway-ticket-review"],
          refresh: ["c-railway-collect-refresh", "c-railway-collect-query", "c-railway-ticket-query"],
          syncPrepay: ["c-railway-collect-syncPrepay", "c-railway-ticket-syncPrepay"],
          savePrepay: ["c-railway-collect-savePrepay", "c-railway-ticket-savePrepay"],
          syncStatement: ["c-railway-collect-syncStatement", "c-railway-ticket-syncStatement"],
          updateContainer: ["c-railway-collect-updateContainer", "c-railway-ticket-updateContainer"]
        }
      };
      return (((permissionMap[module] || {})[action]) || []);
    },
    hasRailwayPermission(module, action) {
      return this.hasAnyPermission(this.getRailwayPermissionKeys(module, action));
    },
    /**
     * 判断当前路由是否仍属于铁路大票管理，避免 keep-alive 离开页面时误触发查询。
     */
    isRailwayTicketRoute(route = this.$route) {
      return route.path.indexOf("/rhqy/service/RailwayTicketManage") === 0;
    },

    /**
     * 根据当前路由 meta 确认业务页，避免二级菜单之间串用筛选条件和勾选记录。
     */
    syncActiveTabFromRoute(reload = true) {
      const routeTab = this.$route.meta.activeTab || "region";
      const nextTab = this.tableConfig[routeTab] ? routeTab : "region";
      if (this.activeTab === nextTab) {
        return;
      }
      this.saveCurrentTabViewState();
      this.activeTab = nextTab;
      if (this.restoreTabViewState(nextTab)) {
        this.scheduleTableLayout();
        return;
      }
      // 首次进入某个业务页时再使用默认筛选和分页，避免页签之间来回切换丢失上下文。
      this.queryParam = {};
      this.pagination = createDefaultPagination();
      this.dataSource = [];
      this.activeTabLoaded = false;
      this.resetTotalCountState();
      this.rowKeySelection = [];
      this.selectedRows = [];
      this.pendingRestoreScrollTop = 0;
      if (nextTab !== "collect") {
        this.resetPendingCollectRefreshSummary();
      }
      if (reload) {
        this.loadData();
      } else {
        this.scheduleTableLayout();
      }
    },

    saveCurrentTabViewState() {
      const currentTab = this.activeTab;
      if (!this.tableConfig[currentTab]) {
        return;
      }
      this.tabViewStateMap = {
        ...this.tabViewStateMap,
        [currentTab]: {
          queryParam: clonePlainData(this.queryParam),
          pagination: clonePlainData(this.pagination),
          dataSource: clonePlainData(this.dataSource),
          total: Number(this.total || 0),
          hasMore: Boolean(this.hasMore),
          totalCountLoaded: Boolean(this.totalCountLoaded),
          rowKeySelection: clonePlainData(this.rowKeySelection),
          selectedRows: clonePlainData(this.selectedRows),
          scrollTop: this.getTableScrollTop(),
          loaded: Boolean(this.activeTabLoaded),
          pendingCollectChangeGroupCount: Number(this.pendingCollectChangeGroupCount || 0),
          pendingCollectCount: Number(this.pendingCollectCount || 0)
        }
      };
    },

    restoreTabViewState(tab) {
      const state = this.tabViewStateMap[tab];
      if (!state || !state.loaded) {
        return false;
      }
      this.queryParam = clonePlainData(state.queryParam);
      this.pagination = {
        ...createDefaultPagination(),
        ...clonePlainData(state.pagination)
      };
      this.dataSource = clonePlainData(state.dataSource || []);
      this.total = Number(state.total || 0);
      this.hasMore = Boolean(state.hasMore);
      this.totalCountLoaded = Boolean(state.totalCountLoaded);
      this.rowKeySelection = clonePlainData(state.rowKeySelection || []);
      this.selectedRows = clonePlainData(state.selectedRows || []);
      this.activeTabLoaded = true;
      this.pendingRestoreScrollTop = Number(state.scrollTop || 0);
      if (tab === "collect") {
        this.pendingCollectChangeGroupCount = Number(state.pendingCollectChangeGroupCount || 0);
        this.pendingCollectCount = Number(state.pendingCollectCount || 0);
        this.pendingCollectSummaryLoading = false;
      } else {
        this.resetPendingCollectRefreshSummary();
      }
      return true;
    },

    getTableBodyWrapper() {
      const table = this.$refs.railwayTicketTable;
      const elTable = table && table.$refs && table.$refs.elTable;
      if (elTable && elTable.bodyWrapper) {
        return elTable.bodyWrapper;
      }
      const tableElement = elTable && elTable.$el ? elTable.$el : (table && (table.$el || table));
      if (!tableElement || typeof tableElement.querySelector !== "function") {
        return null;
      }
      return tableElement.querySelector(".el-table__body-wrapper");
    },

    getTableScrollTop() {
      const bodyWrapper = this.getTableBodyWrapper();
      return bodyWrapper ? Number(bodyWrapper.scrollTop || 0) : 0;
    },

    restoreTableScrollTop() {
      if (this.pendingRestoreScrollTop === null) {
        return;
      }
      const bodyWrapper = this.getTableBodyWrapper();
      if (!bodyWrapper) {
        return;
      }
      const targetScrollTop = Number(this.pendingRestoreScrollTop || 0);
      bodyWrapper.scrollTop = targetScrollTop;
      const finalScrollTop = Number(bodyWrapper.scrollTop || 0);
      if (targetScrollTop === 0 || Math.abs(finalScrollTop - targetScrollTop) <= 1) {
        this.pendingRestoreScrollTop = null;
      }
    },

    handleTableBodyScroll() {
      const currentTab = this.activeTab;
      if (!this.tableConfig[currentTab]) {
        return;
      }
      const currentScrollTop = this.getTableScrollTop();
      const currentState = this.tabViewStateMap[currentTab] || {};
      this.tabViewStateMap = {
        ...this.tabViewStateMap,
        [currentTab]: {
          ...currentState,
          scrollTop: currentScrollTop
        }
      };
    },

    bindTableScrollListener() {
      const bodyWrapper = this.getTableBodyWrapper();
      if (!bodyWrapper) {
        return;
      }
      if (this.tableBodyScrollTarget === bodyWrapper) {
        return;
      }
      this.unbindTableScrollListener();
      bodyWrapper.addEventListener("scroll", this.handleTableBodyScroll, { passive: true });
      this.tableBodyScrollTarget = bodyWrapper;
    },

    unbindTableScrollListener() {
      if (!this.tableBodyScrollTarget) {
        return;
      }
      this.tableBodyScrollTarget.removeEventListener("scroll", this.handleTableBodyScroll);
      this.tableBodyScrollTarget = null;
    },

    scheduleTableLayout() {
      this.$nextTick(() => {
        const table = this.$refs.railwayTicketTable;
        if (!table || typeof table.doLayout !== "function") {
          return;
        }
        table.doLayout();
        this.bindTableScrollListener();
        this.restoreTableScrollTop();
        window.requestAnimationFrame(() => {
          table.doLayout();
          this.bindTableScrollListener();
          this.restoreTableScrollTop();
        });
        window.setTimeout(() => {
          table.doLayout();
          this.bindTableScrollListener();
          this.restoreTableScrollTop();
        }, 60);
        window.setTimeout(() => {
          this.bindTableScrollListener();
          this.restoreTableScrollTop();
        }, 180);
      });
    },

    /**
     * 仅把受价格变更影响、且尚未重新复核通过的字段内容标红。
     */
    collectChangedFieldClass(row) {
      return this.shouldHighlightCollectField(row) ? "railway-ticket-field--highlight" : "";
    },

    /**
     * 价格变更后如果当前仍待复核，则高亮受影响字段；复核通过后恢复默认颜色。
     */
    shouldHighlightCollectField(row) {
      const reviewPassed = Number(row.review_passed || 0) === 1;
      if (reviewPassed) {
        return false;
      }
      const syncUpdated = Number(row.sync_prepay || 0) === 2;
      const reviewTime = Number(row.review_time || 0);
      const updateTime = Number(row.update_time || 0);
      return syncUpdated || (reviewTime > 0 && updateTime > reviewTime);
    },

    /**
     * 重新拉取当前业务表数据。
     */
    async refreshData() {
      this.resetTotalCountState();
      await this.loadData();
    },

    /**
     * 收集复核刷新改为提交后台任务，前端仅负责创建任务并轮询进度。
     */
    async submitCollectRefreshTask() {
      if (this.collectRefreshRunning || this.collectRefreshSubmitting) {
        return;
      }
      this.collectRefreshSubmitting = true;
      try {
        const res = await this.$common.http({
          url: "/api/queue/admin/query_railway_ticket_collect",
          data: {
            ...this.buildCollectRefreshTaskParams(),
            create_refresh_task: 1
          }
        });
        const taskData = (res.data && res.data.data) || {};
        const taskId = String(taskData.task_id || "");
        const matchedCount = Number(taskData.matched_count || 0);
        const usesPendingPriceChanges = Number(taskData.uses_pending_price_changes || 0) === 1;
        const pendingChangeGroupCount = Number(taskData.pending_change_group_count || 0);
        if (!taskId) {
          this.collectRefreshTaskId = "";
          this.collectRefreshTaskPercent = "0.00";
          this.collectRefreshTaskRemark = usesPendingPriceChanges
            ? "当前累计的价格变更暂未命中可刷新的铁路大票收集表数据"
            : "当前筛选范围没有可刷新的数据";
          this.collectRefreshTaskFinished = true;
          await this.loadPendingCollectRefreshSummary();
          this.$message.warning(this.collectRefreshTaskRemark);
          this.pagination.page = 1;
          this.resetTotalCountState();
          await this.loadData();
          return;
        }
        this.collectRefreshTaskId = taskId;
        this.collectRefreshTaskPercent = "0.00";
        this.collectRefreshTaskRemark = usesPendingPriceChanges
          ? `已提交刷新任务，基于 ${pendingChangeGroupCount} 组价格变更处理 ${matchedCount} 条`
          : `已提交刷新任务，待处理 ${matchedCount} 条`;
        this.collectRefreshTaskFinished = false;
        this.$common.pcToastSuccess(this.collectRefreshTaskRemark);
        this.pagination.page = 1;
        this.resetTotalCountState();
        await this.loadData();
        this.$common.http({
          url: "/api/cron/imexport",
          noLoading: true,
          retuenReject: true
        }).catch(() => {});
        this.startCollectRefreshProgressPolling();
      } finally {
        this.collectRefreshSubmitting = false;
      }
    },

    /**
     * 收集复核异步刷新不再带分页，只复用当前筛选条件。
     */
    buildCollectRefreshTaskParams() {
      const params = {
        ...this.queryParam
      };
      Object.keys(params).forEach(key => {
        if (params[key] === "") {
          delete params[key];
        }
      });
      return params;
    },

    hasMeaningfulFilterValue(value) {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      if (typeof value === "string") {
        return value.trim() !== "";
      }
      return value !== "" && value !== null && value !== undefined;
    },

    hasCollectExplicitFilters(params = this.buildCollectRefreshTaskParams()) {
      return ["chip_name", "material_desc", "container_no", "ticket_time", "ticket_time_start", "ticket_time_end", "review_passed", "transport_type", "load_type"].some(field => this.hasMeaningfulFilterValue(params[field]));
    },

    resetPendingCollectRefreshSummary() {
      this.pendingCollectChangeGroupCount = 0;
      this.pendingCollectCount = 0;
      this.pendingCollectSummaryLoading = false;
    },

    async loadPendingCollectRefreshSummary() {
      if (this.activeTab !== "collect") {
        this.resetPendingCollectRefreshSummary();
        return;
      }
      this.pendingCollectSummaryLoading = true;
      try {
        const res = await this.$common.http({
          url: "/api/queue/admin/query_railway_ticket_collect",
          data: {
            pending_change_count_only: 1
          },
          noLoading: true
        });
        const summary = (res.data && res.data.data) || {};
        this.pendingCollectChangeGroupCount = Number(summary.pending_change_group_count || 0);
        this.pendingCollectCount = Number(summary.pending_count || 0);
      } catch (error) {
        this.pendingCollectChangeGroupCount = 0;
        this.pendingCollectCount = 0;
      } finally {
        this.pendingCollectSummaryLoading = false;
        this.saveCurrentTabViewState();
      }
    },

    /**
     * 按当前筛选框条件查询列表，收集复核单独使用，避免和“刷新数据”语义混在一起。
     */
    filterData() {
      this.pagination.page = 1;
      this.resetTotalCountState();
      this.loadData();
    },

    /**
     * 启动收集复核任务进度轮询，并在完成后自动刷新当前列表。
     */
    startCollectRefreshProgressPolling() {
      this.stopCollectRefreshProgressPolling();
      if (!this.collectRefreshTaskId) {
        return;
      }
      const poll = async () => {
        try {
          const res = await this.$common.http({
            url: "/api/queue/admin/get_imexport_progress",
            data: {
              task_id: this.collectRefreshTaskId
            },
            noLoading: true
          });
          const progress = (res.data && res.data.data) || {};
          this.collectRefreshTaskPercent = String(progress.percent || "0.00");
          this.collectRefreshTaskRemark = String(progress.remark || "");
          if (Number(progress.finish) === 1) {
            this.collectRefreshTaskFinished = true;
            this.stopCollectRefreshProgressPolling();
            if (String(this.collectRefreshTaskRemark).indexOf("刷新失败：") === 0) {
              this.$common.pcToastError(this.collectRefreshTaskRemark);
            } else {
              this.$common.pcToastSuccess(this.collectRefreshTaskRemark || "刷新完成");
            }
            if (this.activeTab === "collect") {
              this.resetTotalCountState();
              await this.loadData();
            } else {
              this.resetPendingCollectRefreshSummary();
            }
            return;
          }
        } catch (error) {
          this.collectRefreshTaskRemark = "刷新任务进度查询失败，正在重试";
        }
        this.collectRefreshProgressTimer = window.setTimeout(poll, 1500);
      };
      poll();
    },

    /**
     * 清理收集复核进度轮询定时器。
     */
    stopCollectRefreshProgressPolling() {
      if (this.collectRefreshProgressTimer) {
        window.clearTimeout(this.collectRefreshProgressTimer);
        this.collectRefreshProgressTimer = null;
      }
      if (!this.collectRefreshTaskId) {
        this.collectRefreshTaskFinished = true;
        this.collectRefreshTaskPercent = "0.00";
        this.collectRefreshTaskRemark = "";
      }
    },

    persistPriceSnapshotRefreshState() {
      if (typeof window === "undefined" || !window.localStorage) {
        return;
      }
      if (!this.priceSnapshotRefreshTaskId || this.priceSnapshotRefreshTaskFinished) {
        window.localStorage.removeItem(PRICE_SNAPSHOT_REFRESH_TASK_STORAGE_KEY);
        return;
      }
      window.localStorage.setItem(PRICE_SNAPSHOT_REFRESH_TASK_STORAGE_KEY, JSON.stringify({
        tab: this.priceSnapshotRefreshTab,
        taskId: this.priceSnapshotRefreshTaskId,
        percent: this.priceSnapshotRefreshTaskPercent,
        remark: this.priceSnapshotRefreshTaskRemark,
        finished: this.priceSnapshotRefreshTaskFinished
      }));
    },

    restorePriceSnapshotRefreshState() {
      if (typeof window === "undefined" || !window.localStorage) {
        return;
      }
      try {
        const raw = window.localStorage.getItem(PRICE_SNAPSHOT_REFRESH_TASK_STORAGE_KEY);
        if (!raw) {
          return;
        }
        const taskState = JSON.parse(raw) || {};
        this.priceSnapshotRefreshTab = String(taskState.tab || "");
        this.priceSnapshotRefreshTaskId = String(taskState.taskId || "");
        this.priceSnapshotRefreshTaskPercent = String(taskState.percent || "0.00");
        this.priceSnapshotRefreshTaskRemark = String(taskState.remark || "");
        this.priceSnapshotRefreshTaskFinished = Number(taskState.finished || 0) === 1;
        if (this.priceSnapshotRefreshTaskId && !this.priceSnapshotRefreshTaskFinished) {
          this.startPriceSnapshotRefreshProgressPolling();
        }
      } catch (error) {
        window.localStorage.removeItem(PRICE_SNAPSHOT_REFRESH_TASK_STORAGE_KEY);
      }
    },

    stopPriceSnapshotRefreshProgressPolling() {
      if (this.priceSnapshotRefreshProgressTimer) {
        window.clearTimeout(this.priceSnapshotRefreshProgressTimer);
        this.priceSnapshotRefreshProgressTimer = null;
      }
    },

    resetPriceSnapshotRefreshState() {
      this.stopPriceSnapshotRefreshProgressPolling();
      this.priceSnapshotRefreshSubmitting = false;
      this.priceSnapshotRefreshTab = "";
      this.priceSnapshotRefreshTaskId = "";
      this.priceSnapshotRefreshTaskPercent = "0.00";
      this.priceSnapshotRefreshTaskRemark = "";
      this.priceSnapshotRefreshTaskFinished = true;
      this.priceSnapshotRefreshProgressFailureCount = 0;
      this.persistPriceSnapshotRefreshState();
    },

    shouldClearStalePriceSnapshotTask(message = "") {
      const text = String(message || "");
      return /不存在|已删除|无效|已结束|not\s*found|missing/i.test(text);
    },

    async validatePriceSnapshotRefreshState() {
      if (!this.priceSnapshotRefreshTaskId) {
        this.resetPriceSnapshotRefreshState();
        return false;
      }
      const res = await this.$common.http({
        url: "/api/queue/admin/get_imexport_progress",
        data: {
          task_id: this.priceSnapshotRefreshTaskId
        },
        noLoading: true,
        retuenReject: true
      });
      const errcode = Number(((res || {}).data || {}).errcode || 0);
      const errmsg = String((((res || {}).data || {}).errmsg) || "");
      if (errcode !== 0) {
        this.resetPriceSnapshotRefreshState();
        this.$message.warning(errmsg || "上一次数据更新状态已失效，请重新操作");
        return false;
      }
      const progress = (res.data && res.data.data) || {};
      this.priceSnapshotRefreshTaskPercent = String(progress.percent || "0.00");
      this.priceSnapshotRefreshTaskRemark = String(progress.remark || "");
      if (Number(progress.finish || 0) === 1) {
        this.resetPriceSnapshotRefreshState();
        return false;
      }
      this.persistPriceSnapshotRefreshState();
      return true;
    },

    startPriceSnapshotRefreshProgressPolling() {
      this.stopPriceSnapshotRefreshProgressPolling();
      if (!this.priceSnapshotRefreshTaskId) {
        this.priceSnapshotRefreshTaskFinished = true;
        this.persistPriceSnapshotRefreshState();
        return;
      }
      const poll = async () => {
        try {
          const res = await this.$common.http({
            url: "/api/queue/admin/get_imexport_progress",
            data: {
              task_id: this.priceSnapshotRefreshTaskId
            },
            noLoading: true,
            retuenReject: true
          });
          const errcode = Number(((res || {}).data || {}).errcode || 0);
          const errmsg = String((((res || {}).data || {}).errmsg) || "");
          if (errcode !== 0) {
            if (this.shouldClearStalePriceSnapshotTask(errmsg)) {
              this.resetPriceSnapshotRefreshState();
              this.$message.warning("上一次数据更新状态已失效，请重新操作");
              return;
            }
            this.priceSnapshotRefreshProgressFailureCount += 1;
            if (this.priceSnapshotRefreshProgressFailureCount >= 3) {
              this.resetPriceSnapshotRefreshState();
              this.$message.warning(errmsg || "数据更新状态查询失败，已自动解除锁定，请重新操作");
              return;
            }
            this.priceSnapshotRefreshTaskRemark = errmsg || "数据更新进度查询失败，正在重试";
            this.persistPriceSnapshotRefreshState();
            this.priceSnapshotRefreshProgressTimer = window.setTimeout(poll, 1500);
            return;
          }
          const progress = (res.data && res.data.data) || {};
          this.priceSnapshotRefreshProgressFailureCount = 0;
          this.priceSnapshotRefreshTaskPercent = String(progress.percent || "0.00");
          this.priceSnapshotRefreshTaskRemark = String(progress.remark || "");
          if (Number(progress.finish || 0) === 1) {
            const finishRemark = this.priceSnapshotRefreshTaskRemark || "数据更新完成";
            this.resetPriceSnapshotRefreshState();
            if (String(finishRemark).indexOf("刷新失败：") === 0) {
              this.$common.pcToastError(finishRemark);
            } else {
              this.$common.pcToastSuccess(finishRemark);
            }
            return;
          }
        } catch (error) {
          this.priceSnapshotRefreshProgressFailureCount += 1;
          if (this.priceSnapshotRefreshProgressFailureCount >= 3) {
            this.resetPriceSnapshotRefreshState();
            this.$message.warning("数据更新状态查询失败，已自动解除锁定，请重新操作");
            return;
          }
          this.priceSnapshotRefreshTaskRemark = "数据更新进度查询失败，正在重试";
        }
        this.persistPriceSnapshotRefreshState();
        this.priceSnapshotRefreshProgressTimer = window.setTimeout(poll, 1500);
      };
      this.priceSnapshotRefreshTaskFinished = false;
      this.persistPriceSnapshotRefreshState();
      poll();
    },

    /**
     * 清空当前查询条件，并重新加载当前业务表。
     */
    resetSearch() {
      this.queryParam = {};
      this.pagination = createDefaultPagination();
      this.resetTotalCountState();
      this.rowKeySelection = [];
      this.selectedRows = [];
      this.pendingRestoreScrollTop = 0;
      if (this.activeTab === "collect" && !this.collectRefreshRunning) {
        this.collectRefreshTaskId = "";
        this.collectRefreshTaskPercent = "0.00";
        this.collectRefreshTaskRemark = "";
        this.collectRefreshTaskFinished = true;
      }
      this.loadData();
    },

    /**
     * 查询当前业务表数据。
     */
    async loadData(extraParams = {}) {
      const params = this.buildRequestParams({
        ...(!this.totalCountLoaded ? { with_count: 1 } : {}),
        ...extraParams
      });
      const res = await this.$common.http({
        url: this.activeConfig.fetchUrl,
        data: params
      });
      const pageData = res.data.data || {};
      this.dataSource = pageData.data || [];
      this.hasMore = Boolean(pageData.has_more);
      if (Number(pageData.count_ready) === 1) {
        this.total = Number(pageData.total || pageData.count || 0);
        this.totalCountLoaded = true;
      }
      this.activeTabLoaded = true;
      this.refreshSelectedRows();
      this.scheduleTableLayout();
      if (this.activeTab === "collect") {
        await this.loadPendingCollectRefreshSummary();
      } else {
        this.resetPendingCollectRefreshSummary();
      }
      this.saveCurrentTabViewState();
    },

    /**
     * 查询条件或数据结果变化后，清理旧的总数统计，避免展示过期 count。
     */
    resetTotalCountState() {
      this.total = 0;
      this.hasMore = false;
      this.totalCountLoaded = false;
    },

    /**
     * 无总数模式下使用上一页/下一页翻页，下一页是否可点由后台 has_more 决定。
     */
    changePage(page) {
      const nextPage = Number(page || 1);
      if (nextPage < 1 || nextPage === this.pagination.page) {
        return;
      }
      if (nextPage > this.pagination.page && !this.hasMore) {
        return;
      }
      this.pagination.page = nextPage;
      this.loadData();
    },

    /**
     * 切换每页条数后回到第一页，继续复用当前分页查询逻辑。
     */
    changePageSize(size) {
      const nextSize = Number(size || 10);
      if (nextSize <= 0 || nextSize === Number(this.pagination.page_size || 10)) {
        return;
      }
      this.pagination.page_size = nextSize;
      this.pagination.page = 1;
      this.loadData();
    },

    /**
     * 对账单列表默认不再实时补 SAP，手动点击时才刷新当前页的磅单字段。
     */
    async refreshStatementPoundData() {
      const ids = (this.dataSource || []).map(item => item.id).filter(Boolean);
      if (!ids.length) {
        this.$common.pcToastError("当前页没有可刷新的对账单数据");
        return;
      }
      this.statementRefreshLoading = true;
      try {
        await this.$common.http({
          url: "/api/queue/admin/refresh_railway_statement_pound_detail",
          data: { ids }
        });
        this.$common.pcToastSuccess(`已刷新当前页 ${ids.length} 条对账单的磅单字段`);
        await this.loadData();
      } finally {
        this.statementRefreshLoading = false;
      }
    },

    /**
     * 列表刷新后按勾选的主键重新同步选中行，避免编辑后 selectedRows 仍保留旧快照。
     */
    refreshSelectedRows() {
      if (!this.rowKeySelection.length) {
        this.selectedRows = [];
        return;
      }
      const selectedIdSet = new Set(this.rowKeySelection.map(id => String(id)));
      this.selectedRows = this.dataSource.filter(row => selectedIdSet.has(String(row.id)));
    },

    /**
     * 组装查询参数，过滤空字符串，避免后台收到无效筛选条件。
     */
    buildRequestParams(extraParams = {}) {
      const params = {
        ...this.normalizeQueryBracketParams(this.queryParam),
        ...this.pagination,
        ...extraParams
      };
      if (this.activeTab === "collect") {
        const ticketTimeRange = Array.isArray(params.ticket_time_range)
          ? params.ticket_time_range
          : [];
        params.ticket_time_start = ticketTimeRange[0] || params.ticket_time_start || "";
        params.ticket_time_end = ticketTimeRange[1] || params.ticket_time_end || "";
        delete params.ticket_time_range;
      }
      Object.keys(params).forEach(key => {
        if (
          params[key] === "" ||
          (Array.isArray(params[key]) && params[key].length === 0)
        ) {
          delete params[key];
        }
      });
      return params;
    },

    /**
     * 组装导出参数：有勾选时优先按勾选导出，未勾选时复用当前筛选条件且不传分页。
     */
    buildExportParams() {
      const selectedIds = this.rowKeySelection.map(id => String(id)).filter(Boolean);
      if (selectedIds.length) {
        return {
          ids: selectedIds,
          type: this.activeTab
        };
      }
      const params = this.buildRequestParams();
      delete params.page;
      delete params.page_size;
      return {
        ...params,
        type: this.activeTab
      };
    },

    /**
     * 打开导入弹窗，仅价格维护表允许导入。
     */
    openImport() {
      // #region debug-point C:open-import-entry
      window.fetch("http://127.0.0.1:7777/event", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ sessionId: "railway-import-unavailable", runId: "pre-fix", hypothesisId: "C", location: "RailwayTicketManage.vue:openImport:entry", msg: "[DEBUG] openImport entered", data: { activeTab: this.activeTab, canImport: this.canImport, showImport: this.showImport }, ts: Date.now() }) }).catch(() => {});
      // #endregion
      if (!this.canImport) {
        this.$message.warning("当前模块不支持导入");
        return;
      }
      this.showImport = true;
      // #region debug-point C:open-import-exit
      this.$nextTick(() => {
        window.fetch("http://127.0.0.1:7777/event", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ sessionId: "railway-import-unavailable", runId: "pre-fix", hypothesisId: "C", location: "RailwayTicketManage.vue:openImport:nextTick", msg: "[DEBUG] openImport updated state", data: { activeTab: this.activeTab, showImport: this.showImport, dialogCount: document.querySelectorAll(".importDialog").length }, ts: Date.now() }) }).catch(() => {});
      });
      // #endregion
    },

    /**
     * 导入完成后刷新列表，保留弹窗结果供用户下载成功或失败记录。
     */
    handleImportFinish() {
      this.resetTotalCountState();
      this.refreshData();
    },

    /**
     * 创建当前模块导出任务并下载导出结果。
     */
    async exportData() {
      try {
        this.$common.pcToastLoading("正在导出0.00%...");
        const res = await this.$common.http({
          url: "/api/queue/admin/export_railway_data",
          data: this.buildExportParams(),
          noLoading: true
        });
        const taskId = res.data.data.task_id;
        this.$common.http({
          url: "/api/cron/imexport",
          noLoading: true,
          retuenReject: true
        });
        const { result, remark } = await this.getImexportProgress(taskId);
        this.$common.pcToastClose();
        if (!result || result === "[]") {
          this.$common.pcToastFail(remark || "导出失败");
          return;
        }
        const downloadUrl = result.download_url || result.real_path;
        this.$confirm("导出成功，请点击下载", "提示", {
          showClose: false,
          cancelButtonText: "关闭",
          confirmButtonText: "下载",
          closeOnPressEscape: false,
          closeOnClickModal: false
        }).then(() => {
          this.$common.httpLoadFile({
            url: downloadUrl,
            downloadName: `${this.activeLabel}.xlsx`
          });
        }).catch(() => {});
      } catch (error) {
        this.$common.pcToastClose();
      }
    },

    /**
     * 轮询导出任务进度。
     */
    getImexportProgress(taskId) {
      return new Promise((resolve, reject) => {
        const progressFunc = async () => {
          try {
            const res = await this.$common.http({
              url: "/api/queue/admin/get_imexport_progress",
              data: {
                task_id: taskId
              },
              noLoading: true
            });
            const { finish, percent, remark, result } = res.data.data;
            this.$common.pcToastLoadingUpdate(`正在导出 ${percent}%...`, 1);
            if (finish === 1) {
              resolve({ result, remark });
            } else {
              setTimeout(progressFunc, 1000);
            }
          } catch (error) {
            reject(error);
          }
        };
        progressFunc();
      });
    },

    /**
     * 审核区域价或专厂价，审核后价格才参与大票匹配。
     */
    async auditPrice(type, row) {
      const url = type === "region"
        ? "/api/queue/admin/audit_railway_region_price"
        : "/api/queue/admin/audit_railway_factory_price";
      const priceLabel = type === "region" ? "区域价" : "专厂价";
      const isAudited = Number(row.audit_state) === 1;
      const confirmText = isAudited
        ? `确认将当前${priceLabel}改为未审核？`
        : `确认审核通过当前${priceLabel}？`;
      this.$confirm(confirmText, "提示").then(async () => {
        try {
          const res = await this.$common.http({
            url,
            data: {
              id: row.id
            },
            noLoading: true
          });
          const auditResult = (((res || {}).data || {}).data) || {};
          const nextAuditState = Number(auditResult.audit_state || (((auditResult.model || {}).audit_state) || 0));
          const toastText = nextAuditState === 1
            ? `${priceLabel}审核通过，请到铁路大票收集表页面点击“刷新数据”同步最新结果`
            : `${priceLabel}已改为未审核，如需同步铁路大票收集表，请到铁路大票收集表页面点击“刷新数据”`;
          this.$common.pcToastSuccess(toastText);
          await this.loadData();
        } finally {
          this.resetPriceSnapshotRefreshState();
        }
      }).catch(() => {});
    },

    /**
     * 作废区域价或专厂价，作废后不再参与大票匹配。
     */
    async voidPrice(type, row) {
      const url = type === "region"
        ? "/api/queue/admin/void_railway_region_price"
        : "/api/queue/admin/void_railway_factory_price";
      const priceLabel = type === "region" ? "区域价" : "专厂价";
      this.$confirm(`确认作废当前${priceLabel}？作废后该价格将不再参与大票价格匹配。`, "提示").then(async () => {
        try {
          await this.$common.http({
            url,
            data: { id: row.id },
            noLoading: true
          });
          this.$common.pcToastSuccess(`${priceLabel}已作废，不再参与匹配`);
          await this.loadData();
        } finally {
          this.resetPriceSnapshotRefreshState();
        }
      }).catch(() => {});
    },

    /**
     * 删除选中的大票收集记录，已同步预付款的数据由后端拦截。
     */
    deleteCollect() {
      if (!this.rowKeySelection.length) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除选中的收集记录？", "提示").then(async () => {
        await this.$common.http({
          url: "/api/queue/admin/delete_railway_ticket_collect",
          data: {
            ids: this.rowKeySelection
          }
        });
        this.$common.pcToastSuccess("删除成功");
      this.resetTotalCountState();
        this.rowKeySelection = [];
        this.selectedRows = [];
        this.loadData();
      }).catch(() => {});
    },

    /**
     * 打开新增、编辑、复核或改箱号弹窗。
     */
    openEdit(type, row = {}) {
      if (type === "container" && Number(row.sync_prepay) !== 0) {
        this.$message.warning("已同步预付款的收集结果不能再修改");
        return;
      }
      this.editType = type;
      this.editAuditState = Number(row.audit_state || 0);
      // 关键步骤：保留原记录 id，后台据此更新对应业务表或下游单据。
      this.editForm = {
        ...this.defaultEditForm(type),
        ...JSON.parse(JSON.stringify(row))
      };
      if (type === "review" && Number(row.sync_prepay) === 1) {
        this.editForm.review_passed = 0;
      }
      this.normalizeEditFormDates();
      this.normalizeEditFormBracketFields();
      this.editVisible = true;
    },
    openRecordLog(bizType, row = {}) {
      const bizId = String(row.id || "");
      if (!bizId) {
        this.$message.warning("当前记录缺少日志ID");
        return;
      }
      this.logContext = {
        bizType,
        bizId,
        label: this.tabLabelMap[bizType] || this.activeLabel
      };
      this.logQuery = {
        page: 1,
        page_size: 10
      };
      this.logVisible = true;
      this.loadRecordLogs();
    },
    async loadRecordLogs() {
      if (!this.logContext.bizId || !this.logContext.bizType) {
        return;
      }
      this.logLoading = true;
      try {
        const res = await this.$common.http({
          url: "/api/queue/admin/query_railway_record_log",
          data: {
            biz_type: this.logContext.bizType,
            biz_id: this.logContext.bizId,
            page: this.logQuery.page,
            page_size: this.logQuery.page_size,
            with_count: 1
          },
          noLoading: true
        });
        const pageData = (res.data && res.data.data) || {};
        this.logRows = this.normalizeRecordLogRows(pageData.data || []);
        this.logTotal = Number(pageData.count || 0);
      } finally {
        this.logLoading = false;
      }
    },
    changeLogPage(page) {
      const nextPage = Number(page || 1);
      if (nextPage < 1 || nextPage === Number(this.logQuery.page || 1)) {
        return;
      }
      this.logQuery.page = nextPage;
      this.loadRecordLogs();
    },

    /**
     * 对账单页允许单独改箱号，用于重新匹配磅单号和司磅净重。
     */
    openStatementContainerEdit(row) {
      if (!row.ticket_collect_id) {
        this.$message.warning("当前对账单缺少来源收集记录，暂不能改箱号");
        return;
      }
      this.openEdit("container", {
        ...row,
        id: row.ticket_collect_id,
        allow_synced: 1
      });
    },

    /**
     * 根据弹窗类型给新增场景提供默认状态。
     */
    defaultEditForm(type) {
      if (type === "collectManual") {
        return {
          order_code: "",
          material_desc: "",
          supplier_name: "",
          shipper_name: "",
          start_weight: "",
          ticket_time: "",
          departure_station: "",
          arrival_station: "",
          load_type: "",
          transport_type: "",
          container_no: "",
          chip_name: "",
          submit_account: "",
          ticket_file: []
        };
      }
      if (type === "review") {
        return { review_passed: 1 };
      }
      if (type === "prepay") {
        return { prepay_audit: 1, approval_passed: 1 };
      }
      return {};
    },

    /**
     * 弹窗字段读取下拉选项。
     */
    fieldOptions(field) {
      return this[field.optionsKey] || [];
    },

    normalizeParenthesesText(value) {
      return String(value || "")
        .replace(/\(/g, "（")
        .replace(/\)/g, "）")
        .replace(/\s*（\s*/g, "（")
        .replace(/\s*）\s*/g, "）")
        .trim();
    },

    normalizeEditFormBracketFields() {
      const fields = EDIT_BRACKET_FIELDS_MAP[this.editType] || [];
      fields.forEach(field => {
        if (typeof this.editForm[field] === "string") {
          this.$set(this.editForm, field, this.normalizeParenthesesText(this.editForm[field]));
        }
      });
    },

    normalizeQueryBracketParams(params = {}) {
      const normalizedParams = {};
      Object.keys(params).forEach(key => {
        const value = params[key];
        if (typeof value === "string") {
          normalizedParams[key] = this.normalizeParenthesesText(value);
          return;
        }
        if (Array.isArray(value)) {
          normalizedParams[key] = value.map(item =>
            typeof item === "string" ? this.normalizeParenthesesText(item) : item
          );
          return;
        }
        normalizedParams[key] = value;
      });
      return normalizedParams;
    },

    /**
     * 保存当前弹窗表单。
     */
    saveDialog() {
      this.normalizeEditFormBracketFields();
      this.$refs.editForm.validate(valid => {
        if (valid) {
          if (this.editType === "review" && this.reviewNeedsSettlementPrice() && !(Number(this.editForm.settlement_price) > 0)) {
            this.$message.warning("命中专厂价时，结算价需人工填写且大于0");
            return;
          }
          if (this.editType === "prepay" && !this.validatePrepayForm()) {
            return;
          }
          if (this.needReauditConfirm()) {
            this.$confirm("修改后将自动变为未审核，需重新审核后生效，是否继续？", "提示").then(() => {
              this.submitDialog();
            }).catch(() => {});
            return;
          }
          this.submitDialog();
        }
      });
    },

    /**
     * 提交当前弹窗数据到对应后台接口。
     */
    async submitDialog() {
      this.normalizeEditFormDates();
      const submitData = clonePlainData(this.editForm);
      if (this.editType === "collectManual") {
        submitData.ticket_file = JSON.stringify(Array.isArray(submitData.ticket_file) ? submitData.ticket_file : []);
      }
      await this.$common.http({
        url: this.saveUrlMap[this.editType],
        data: submitData
      });
      this.$common.pcToastSuccess("操作成功");
      this.resetTotalCountState();
      this.editVisible = false;
      this.loadData();
    },

    /**
     * 关闭弹窗时清理表单状态。
     */
    handleDialogClose() {
      this.editAuditState = 0;
      this.editForm = {};
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate();
      });
    },
    handleRecordLogDialogClose() {
      this.logLoading = false;
      this.logRows = [];
      this.logTotal = 0;
      this.logContext = {
        bizType: "",
        bizId: "",
        label: ""
      };
      this.logQuery = {
        page: 1,
        page_size: 10
      };
    },

    /**
     * 已审核的价格维护数据再次编辑时，需要提示保存后会重新进入待审核状态。
     */
    needReauditConfirm() {
      return ["region", "factory", "prepayRatio"].includes(this.editType)
        && !!this.editForm.id
        && this.editAuditState === 1;
    },

    /**
     * 批量同步收集记录到预付款，或预付款到对账单。
     */
    syncSelected(type) {
      if (!this.rowKeySelection.length) {
        this.$message.warning("请选择要同步的数据");
        return;
      }
      if (type === "prepay") {
        const invalidRows = this.selectedRows.filter(row => !this.canSyncPrepayRow(row));
        if (invalidRows.length) {
          this.$message.warning("仅人工复核已通过、结算价大于0且状态为待同步、数据已更新或同步失败的数据可同步");
          return;
        }
      } else {
        const invalidRows = this.selectedRows.filter(row => !this.canSyncStatementRow(row));
        if (invalidRows.length) {
          this.$message.warning("仅集装箱、申请信息完整、预付款审核已通过、审核通过已通过且待同步或需更新对账单的数据可同步");
          return;
        }
      }
      const url = type === "prepay"
        ? "/api/queue/admin/sync_railway_ticket_prepay"
        : "/api/queue/admin/sync_railway_statement";
      const title = type === "prepay" ? "确认同步至预付款申请表？" : "确认同步至对账单？";
      this.$confirm(title, "提示").then(async () => {
        const res = await this.$common.http({
          url,
          data: {
            ids: this.rowKeySelection
          }
        });
        const syncResult = (((res || {}).data || {}).data) || [];
        const syncedIds = Array.isArray(syncResult) ? syncResult : (syncResult.synced_ids || []);
        const failedIds = Array.isArray(syncResult) ? [] : (syncResult.failed_ids || []);
        if (type === "prepay") {
          if (!syncedIds.length && failedIds.length) {
            this.$message.warning("所选收集结果对应的预付款已完成审核并审核通过，已标记为同步失败");
          } else if (!syncedIds.length) {
            this.$message.warning("所选收集结果未生成或未更新预付款申请，请确认已人工复核通过且结算价大于0");
            return;
          } else if (failedIds.length) {
            this.$common.pcToastSuccess(`已同步 ${syncedIds.length} 条到预付款申请表，${failedIds.length} 条标记为同步失败`);
          } else {
            this.$common.pcToastSuccess(`已同步 ${syncedIds.length} 条到预付款申请表`);
          }
        } else {
          if (!syncedIds.length) {
            this.$message.warning("所选预付款记录未生成或未更新对账单，请确认装载方式为集装箱、申请信息完整且状态为待同步或数据已更新");
            return;
          }
          this.$common.pcToastSuccess(`已同步 ${syncedIds.length} 条到对账单`);
        }
        this.resetTotalCountState();
        this.rowKeySelection = [];
        this.selectedRows = [];
        this.loadData();
      }).catch(() => {});
    },

    /**
     * 批量下载当前勾选行的铁路大票附件，下载文件名按“制票时间+木片厂+供应商+物料描述”生成。
     */
    async downloadSelectedAttachments() {
      // #region debug-point A:download-selected-entry
      this.reportDownloadDebug("A", "RailwayTicketManage.vue:1026", "downloadSelectedAttachments invoked", {
        selectedRowCount: this.selectedRows.length,
        selectedIds: this.selectedRows.map(row => row.id)
      });
      // #endregion
      if (!this.selectedRows.length) {
        this.$message.warning("请选择要下载附件的数据");
        return;
      }
      const rows = this.selectedRows.filter(row => this.ticketFiles(row).length);
      // #region debug-point A:download-selected-filtered
      this.reportDownloadDebug("A", "RailwayTicketManage.vue:1037", "filtered downloadable rows", {
        selectedRowCount: this.selectedRows.length,
        downloadableRowCount: rows.length,
        downloadableIds: rows.map(row => row.id)
      });
      // #endregion
      if (!rows.length) {
        this.$message.warning("所选数据没有可下载的附件");
        return;
      }
      try {
        for (const row of rows) {
          const files = this.ticketFiles(row);
          for (let index = 0; index < files.length; index += 1) {
            const file = files[index];
            const ext = this.ticketFileExt(file);
            const downloadName = this.buildTicketDownloadName(row, ext, index, files.length);
            const downloadUrl = this.ticketFileUrl(file);
            // #region debug-point B:download-url-fetched
            this.reportDownloadDebug("B", "RailwayTicketManage.vue:1054", "backend download url built", {
              rowId: row.id,
              downloadName,
              downloadUrl
            });
            // #endregion
            if (!downloadUrl) {
              // #region debug-point B:download-url-empty
              this.reportDownloadDebug("B", "RailwayTicketManage.vue:1062", "download url empty", {
                rowId: row.id,
                downloadName
              });
              // #endregion
              throw new Error("empty download url");
            }
            await this.$common.httpLoadFile({
              url: downloadUrl,
              method: "GET",
              downloadName
            });
            // #region debug-point A:download-file-resolved
            this.reportDownloadDebug("A", "RailwayTicketManage.vue:1072", "httpLoadFile resolved", {
              rowId: row.id,
              downloadName,
              downloadUrl
            });
            // #endregion
            await this.delay(200);
          }
        }
        const fileCount = rows.reduce((sum, row) => sum + this.ticketFiles(row).length, 0);
        this.$common.pcToastSuccess(`已开始下载 ${fileCount} 个附件`);
      } catch (error) {
        // #region debug-point D:download-selected-error
        this.reportDownloadDebug("D", "RailwayTicketManage.vue:1081", "downloadSelectedAttachments failed", {
          message: error && error.message ? error.message : String(error)
        });
        // #endregion
        this.$message.warning("附件下载失败，请稍后重试");
      }
    },

    /**
     * 解析附件 JSON，返回首个附件地址。
     */
    ticketFiles(row) {
      const parsed = this.parseTicketFile(row);
      if (!parsed) {
        return [];
      }
      const files = Array.isArray(parsed) ? parsed : [parsed];
      return files.filter(file => file && typeof file === "object" && file.real_path);
    },

    ticketFileUrl(fileOrRow) {
      if (fileOrRow && typeof fileOrRow === "object" && fileOrRow.real_path) {
        return String(fileOrRow.real_path || "");
      }
      const files = this.ticketFiles(fileOrRow);
      return files.length ? String(files[0].real_path || "") : "";
    },

    /**
     * 查看 PDF 时优先跳转 OCR 对应页；历史记录没有页码时，退化为按集装箱号搜索。
     */
    ticketFileViewerUrl(row, file = null) {
      const fileInfo = file || this.ticketFiles(row)[0] || null;
      const url = this.ticketFileUrl(fileInfo);
      if (!url) {
        return "";
      }
      if (!this.isPdfTicketFile(fileInfo)) {
        return url;
      }
      const pageIndex = this.ticketFilePageIndex(row);
      if (pageIndex > 0) {
        return this.appendPdfFragment(url, `page=${pageIndex}`);
      }
      const searchKeyword = String(row.container_no || "").trim();
      if (searchKeyword) {
        return this.appendPdfFragment(url, `search=${encodeURIComponent(searchKeyword)}`);
      }
      return url;
    },

    /**
     * 解析附件 JSON，统一返回附件对象。
     */
    parseTicketFile(row) {
      try {
        return typeof row.ticket_file === "string" ? JSON.parse(row.ticket_file) : row.ticket_file;
      } catch (error) {
        return null;
      }
    },

    parseTicketOcrRawResponse(row) {
      try {
        return typeof row.ocr_raw_response === "string" ? JSON.parse(row.ocr_raw_response) : row.ocr_raw_response;
      } catch (error) {
        return null;
      }
    },

    ticketFilePageIndex(row) {
      const raw = this.parseTicketOcrRawResponse(row);
      if (!raw || typeof raw !== "object") {
        return 0;
      }
      const candidates = [
        raw.page_index,
        raw.data && raw.data.page_index,
        raw.data && Array.isArray(raw.data.data) && raw.data.data[0] && raw.data.data[0].page_index,
        raw.data && Array.isArray(raw.data.pages) && raw.data.pages[0] && raw.data.pages[0].page_index,
        raw.raw_response && raw.raw_response.page_index,
        raw.raw_response && raw.raw_response.data && raw.raw_response.data.page_index
      ];
      for (const candidate of candidates) {
        const pageIndex = Number(candidate || 0);
        if (pageIndex > 0) {
          return pageIndex;
        }
      }
      return 0;
    },

    isPdfTicketFile(fileOrRow) {
      const file = fileOrRow && typeof fileOrRow === "object" && fileOrRow.real_path
        ? fileOrRow
        : (this.ticketFiles(fileOrRow)[0] || null);
      const ext = file && file.ext ? String(file.ext).toLowerCase().replace(/^\./, "") : "";
      const path = file && file.real_path ? String(file.real_path).toLowerCase() : "";
      return ext === "pdf" || path.endsWith(".pdf");
    },

    appendPdfFragment(url, fragment) {
      const baseUrl = String(url || "").split("#")[0];
      return `${baseUrl}#${fragment}`;
    },

    /**
     * 解析附件后缀，批量下载时用于保留原始文件扩展名。
     */
    ticketFileExt(fileOrRow) {
      const file = fileOrRow && typeof fileOrRow === "object" && fileOrRow.real_path
        ? fileOrRow
        : (this.ticketFiles(fileOrRow)[0] || null);
      return file && file.ext ? `.${String(file.ext).replace(/^\./, "")}` : "";
    },

    /**
     * 构建附件下载文件名，避免直接使用原始文件名导致无法区分业务归属。
     */
    buildTicketDownloadName(row, ext = "", fileIndex = 0, total = 1) {
      const parts = [
        row.chip_name || "未知木片厂",
        this.formatFileDateValue(row.ticket_time).replace(/--/g, "未知日期"),
        row.departure_station || "未知发站",
        row.container_no || "未知集装箱号"
      ];
      if (total > 1) {
        parts.push(`附件${fileIndex + 1}`);
      }
      const fileName = parts.join("_").replace(/[\\/:*?"<>|]/g, "_");
      return `${fileName}${ext}`;
    },

    formatSubmitTime(value) {
      if (value === "" || value === null || value === undefined) {
        return "--";
      }
      const numeric = Number(value);
      if (Number.isFinite(numeric) && numeric > 0) {
        return moment.unix(numeric).utcOffset(8).format("YY/MM/DD");
      }
      const date = moment(String(value), ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm", "YYYY/MM/DD HH:mm:ss", "YYYY/MM/DD HH:mm"], true);
      if (date.isValid()) {
        return date.utcOffset(8, true).format("YY/MM/DD");
      }
      return value;
    },

    formatCollectSubmitType(value) {
      return Number(value) === 2 ? "手工添加" : "APP提交";
    },

    delay(ms) {
      return new Promise(resolve => {
        setTimeout(resolve, ms);
      });
    },

    // #region debug-point A:report-helper
    reportDownloadDebug(hypothesisId, location, msg, data = {}) {
      if (!ENABLE_DOWNLOAD_DEBUG || typeof fetch !== "function") {
        return;
      }
      fetch(DEBUG_DOWNLOAD_SERVER_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          sessionId: DEBUG_DOWNLOAD_SESSION_ID,
          runId: DEBUG_DOWNLOAD_RUN_ID,
          hypothesisId,
          location,
          msg: `[DEBUG] ${msg}`,
          data,
          ts: Date.now()
        })
      }).catch(() => {});
    },
    // #endregion

    /**
     * 格式化审核状态。
     */
    formatAuditState(value) {
      return Number(value) === 1 ? "已审核" : "未审核";
    },

    /**
     * 价格维护页审核状态优先展示作废，避免已作废记录仍显示为已审核。
     */
    formatPriceAuditStatus(row) {
      if (Number((row || {}).void_state || 0) === 1) {
        return "作废";
      }
      return Number((row || {}).audit_state || 0) === 1 ? "已审核" : "未审核";
    },

    /**
     * 格式化通过状态。
     */
    formatReviewState(value) {
      return Number(value) === 1 ? "已通过" : "未通过";
    },

    /**
     * 格式化是否状态。
     */
    formatYesNo(value) {
      return Number(value) === 1 ? "是" : "否";
    },

    /**
     * 统一格式化日期字符串，表格展示按 yy/MM/dd 输出。
     */
    formatDateValue(value) {
      if (!value) {
        return "--";
      }
      const date = moment(String(value), ["YYYY-MM-DD", "YYYY/M/D", "M/D/YYYY", "YYYY/M/DD", "YYYY/MM/DD"], true);
      return date.isValid() ? date.format("YY/MM/DD") : value;
    },

    /**
     * 下载文件名中的日期单独使用安全格式，避免斜杠影响文件保存。
     */
    formatFileDateValue(value) {
      if (!value) {
        return "--";
      }
      const date = moment(String(value), ["YYYY-MM-DD", "YYYY/M/D", "M/D/YYYY", "YYYY/M/DD", "YYYY/MM/DD"], true);
      return date.isValid() ? date.format("YY-MM-DD") : value;
    },

    /**
     * 预付比例统一按百分比展示，便于业务理解实际比例。
     */
    formatPercentValue(value) {
      if (value === "" || value === null || value === undefined) {
        return "--";
      }
      const number = Number(value);
      return Number.isFinite(number) ? `${(number * 100).toFixed(2).replace(/\.00$/, "")}%` : value;
    },

    /**
     * 编辑弹窗提交前统一规整日期字段，保证保存值始终为 yyyy-MM-dd。
     */
    normalizeEditFormDates() {
      const dateFields = (this.currentEditFields || [])
        .filter(field => field.type === "date")
        .map(field => field.prop);
      dateFields.forEach(prop => {
        const value = this.editForm[prop];
        if (!value) {
          return;
        }
        const date = moment(String(value), ["YYYY-MM-DD", "YYYY/M/D", "M/D/YYYY", "YYYY/M/DD", "YYYY/MM/DD"], true);
        if (date.isValid()) {
          this.$set(this.editForm, prop, date.format("YYYY-MM-DD"));
        }
      });
    },

    /**
     * 收集复核命中专厂价时，结算价需要人工填写。
     */
    reviewNeedsSettlementPrice() {
      return this.editType === "review" && Number(this.editForm.factory_price || 0) > 0;
    },

    /**
     * 收集结果同步至预付款的前端判定规则。
     */
    canSyncPrepayRow(row) {
      return Number(row.review_passed) === 1
        && Number(row.sync_prepay) !== 1
        && Number(row.settlement_price || 0) > 0;
    },

    /**
     * 预付款申请同步至对账单的前端判定规则。
     */
    canSyncStatementRow(row) {
      return String(row.load_type || "") === "集装箱"
        && Number(row.sync_statement) !== 1
        && Number(row.prepay_audit) === 1
        && Number(row.approval_passed) === 1
        && this.hasPrepayApplyInfo(row);
    },

    /**
     * 预付款申请同步前必须具备申请时间和申请单。
     */
    hasPrepayApplyInfo(row) {
      return !!String(row.prepay_apply_time || "").trim()
        && !!String(row.prepay_apply_no || "").trim();
    },

    /**
     * 预付款审核弹窗的前端校验，优先给出明确业务提示。
     */
    validatePrepayForm() {
      if (Number(this.editForm.approval_passed) === 1 && Number(this.editForm.prepay_audit) !== 1) {
        this.$message.warning("预付款审核未通过时，审核通过不能勾选已通过");
        return false;
      }
      if (Number(this.editForm.prepay_audit) === 1) {
        if (!String(this.editForm.prepay_apply_time || "").trim()) {
          this.$message.warning("预付款审核通过时，预付申请时间不能为空");
          return false;
        }
        if (!String(this.editForm.prepay_apply_no || "").trim()) {
          this.$message.warning("预付款审核通过时，预付申请单不能为空");
          return false;
        }
      }
      return true;
    },

    /**
     * 格式化勾选标记，符合方案中“同步成功标识√、未同步为空”的展示要求。
     */
    formatCheckMark(value) {
      return Number(value) === 1 ? "√" : "";
    },

    /**
     * 收集复核页的同步至预付款状态分为：未同步、已同步、数据已更新、同步失败。
     */
    formatSyncPrepayStatus(value) {
      if (Number(value) === 1) {
        return "√";
      }
      if (Number(value) === 2) {
        return "数据已更新";
      }
      if (Number(value) === 3) {
        return "同步失败";
      }
      return "--";
    },

    /**
     * 预付款申请页的同步至对账单状态分为：未同步、已同步、数据已更新。
     */
    formatSyncStatementStatus(value) {
      if (Number(value) === 1) {
        return "√";
      }
      if (Number(value) === 2) {
        return "数据已更新";
      }
      return "--";
    },

    /**
     * 审核/复核勾选列统一显示：通过为 √，未通过为 --。
     */
    formatTickOrDash(value) {
      return Number(value) === 1 ? "√" : "--";
    },

    /**
     * 格式化 Unix 时间戳，表格统一展示为 yy/MM/dd。
     */
    formatUnixTime(value) {
      return Number(value) > 0 ? moment.unix(Number(value)).format("YY/MM/DD") : "--";
    },
    normalizeRecordLogRows(rows = []) {
      return rows.map(row => ({
        ...row,
        _changeDetailList: this.parseRecordLogChangeDetail(row.change_detail)
      }));
    },
    parseRecordLogChangeDetail(value) {
      let list = [];
      if (Array.isArray(value)) {
        list = value;
      } else if (typeof value === "string" && value.trim()) {
        try {
          const parsed = JSON.parse(value);
          list = Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          list = [];
        }
      }
      return list
        .map(item => ({
          field: String((item || {}).field || ""),
          label: String((item || {}).label || ""),
          before: String((item || {}).before || "--"),
          after: String((item || {}).after || "--")
        }))
        .filter(item => item.label);
    },
    formatDateTime(value) {
      return Number(value) > 0 ? moment.unix(Number(value)).format("YYYY-MM-DD HH:mm:ss") : "--";
    }
  }
};
</script>

<style lang="less" scoped>
.viewsrhqy_RailwayTicketManage {
  height: calc(100vh - 88px);
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.search-form-inline,
.table-toolbar {
  flex-shrink: 0;
}

.search-form-inline--collect {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.railway-collect-actions-item,
.railway-collect-secondary-actions-item {
  flex: 0 0 auto;
  margin-right: 16px;
}

/deep/ .railway-collect-actions-item .el-form-item__content,
/deep/ .railway-collect-secondary-actions-item .el-form-item__content {
  display: block;
  width: auto;
}

/deep/ .search-form-inline--collect .railway-collect-ticket-time.el-date-editor,
/deep/ .search-form-inline--collect .railway-collect-ticket-time .el-input__inner {
  width: 136px;
}

/deep/ .search-form-inline--collect .railway-collect-review-passed {
  width: 112px;
}

.railway-collect-filter-item {
  margin-right: 16px;
}

.railway-collect-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  width: auto;
}

.railway-collect-actions--primary {
  justify-content: flex-start;
  flex-wrap: wrap;
}

.railway-collect-actions--secondary {
  justify-content: flex-start;
  flex-wrap: wrap;
}

.railway-ticket-table {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/deep/ .railway-ticket-table.ScTable {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/deep/ .railway-ticket-table--sticky .el-table {
  flex: 1;
  min-height: 0;
}

/deep/ .railway-ticket-table--sticky .el-table__body-wrapper {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

/deep/ .railway-ticket-table--sticky .page-wrap {
  position: sticky;
  bottom: 0;
  z-index: 5;
  margin-top: 0;
  padding-top: 12px;
  background: #fff;
  border-top: 1px solid #ebeef5;
}

/deep/ .railway-ticket-field--highlight {
  color: #f56c6c !important;
}

.railway-pagination-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #727272;
  font-size: 12px;
}

.railway-pagination-bar__summary {
  display: flex;
  align-items: center;
  gap: 8px;
}

.railway-pagination-bar__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.railway-pagination-bar__size {
  width: 112px;
}

.railway-pagination-bar__page-select {
  width: 120px;
}

.railway-action-group {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.railway-action-group--double {
  gap: 12px;
}

.railway-action-group--single {
  min-height: 20px;
  gap: 8px;
}

.railway-action--voided {
  color: #C0C4CC;
  cursor: not-allowed;
}

.railway-action-slot {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/deep/ .el-table .railway-action-column > .cell,
/deep/ .el-table__fixed-right .railway-action-column > .cell,
/deep/ .el-table__fixed .railway-action-column > .cell {
  padding-left: 0 !important;
  padding-right: 0 !important;
  text-align: center;
}

.railway-refresh-progress {
  color: #409eff;
  font-size: 12px;
}

.railway-pending-summary {
  color: #606266;
  font-size: 12px;
}

.railway-dialog--compact /deep/ .el-form-item {
  margin-bottom: 12px;
}

.railway-dialog--compact /deep/ .el-form-item__label {
  line-height: 32px;
}

.railway-dialog--compact /deep/ .el-input__inner,
.railway-dialog--compact /deep/ .el-textarea__inner {
  height: 32px;
  line-height: 32px;
}

.railway-dialog--compact /deep/ .el-textarea__inner {
  height: auto;
  min-height: 32px;
}

.railway-log-dialog__pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.railway-log-content {
  line-height: 20px;
}

.railway-log-detail-list {
  margin-top: 6px;
}

.railway-log-detail-item {
  line-height: 20px;
  color: #606266;
  word-break: break-all;
}

.railway-log-detail-item__label {
  color: #303133;
}
</style>
